import React, { Component } from "react";

import {
  isObject,
  isSet,
  toQueryString,
  getShortenedVisitCategoryName,
  encryptString,
  getCurrentDate,
} from "../../../utils/commonUtils";
import Buttons from "../../../components/UI/Buttons";
import WithRoutify from "../../../hoc/WithRoutify";
import VisitsService from "../../../services/VisitsService";
import UserService from "../../../services/UserService";
import EmployeeService from "../../../services/EmployeeService";
import withReduxState from "../../../hoc/wReduxState";
import AddVisits from "../AddVisits";
import { acl_check } from "../../../utils/aclUtils";
import EmployeeDetails from "../../EmployeeContainer/EmployeeDetails";
import AddEmployee from "../../EmployeeContainer/AddEmployee";
import WithRouter from "../../../hoc/WithRouter";
import VisitDetails from "./../VisitDetails";
import AddLab from "../AddLab";
import AddFollowUp from "../AddFollowUp";
import AddPhysical from "../AddPhysical";
import PERMISSIONS from "../../../utils/AclPermissions";
import MiniPopup from "../../../components/Modal/MiniPopup";
import {
  getActiveIds,
  getBillingStatusColor,
  getOverAllStatusIcon,
  getVisitStatusIcon,
  isWorkCompVisitCategory,
} from "../../../utils/visitUtils";
import { isLaboratoryVisitCategory } from "../../../utils/visitUtils";
import ScanbarCodePopup from "../../EmployeeContainer/ScanbarCodePopup";
import Icons from "../../../components/UI/Icons";
import { connect } from "react-redux";
import {
  clearCbState,
  setActiveIds,
  setSelectedAllRecords,
  setShowScheduledVisits,
  getShowScheduledVisits,
} from "../../../store/GlobalFilterSlice";
import { setProfileDetails } from "../../../store/SessionSlice";
import CsvService from "../../../services/CsvService";
import FileManagerService from "../../../services/FileManagerService";
import PatientChartsService from "../../../services/PatientChartsService";
import EmrVisitsService from "../../../services/EmrVisitsService";
import { OK } from "../../../utils/constant";
import UpdateBillingStatusModal from "../../../components/Modal/UpdateBillingStatusModal";
import WithDropdownState from "../../../hoc/WithDropdownState";
import FormInputs from "../../../components/UI/FormInputs";
import DropDownService from "../../../services/DropDownService";
// import NewTableGrid from "../../../components/UI/NewTableGrid";
import { ToastContext } from "../../../context/ToaxtContext";
import TableGrid from "../../../components/UI/TableGrid";
import ConsentFormService from "../../../services/ConsentFormService";
import OrganizationService from "../../../services/OrganizationService";
import AddAuthorizationTreatment from "../AddAuthorizationTreatment";
import AddIncidentModal from "../AddIncidentModal";
import GlobalSearch from "../../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";
import SendTaskModal from "../../../components/Modal/SendTaskModal";
import DaisyBillService from "../../../services/DaisyBillService";
import AuditLogService from "../../../services/AuditLogService";
import TranscriptionRecordingModal from "./TranscriptionRecordingModal";
import VisitAiAuditModal from "./VisitAiAuditModal";
import "./VisitsListNew.mobile.css";
// Manual document upload modal - commented out, auto-upload chart note is used instead
// import DaisyBillDocumentUploadModal from "../../../components/Modal/DaisyBillDocumentUploadModal";
import { PatientFormModelWithHoc } from "../PatientFormModel";
import KioskPinSetupModal from "../../../components/Modal/KioskPinSetupModal";
import {
  getVoiceToolbarUi,
  isVoiceTranscriptionListCategory,
  voiceDocProgressFromVisitListRow,
} from "../../../utils/transcriptionUtils";
class VisitsListNew extends Component {
  static contextType = ToastContext;
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const initialFilters = {
      first_name: "",
      last_name: "",
      gender: "",
      company_id: "",
      dob: "",
      visit_status: "Active",
      is_scheduled_visit: "ALL",
      patient_id: "",
      clinic_location_id: "",
      phone: "",
      patient_id: "",
      identification_type: "",
      identification_number: "",
      clinic_id: "",
      booking_id: "",
      pre_registration_code: "",
      employee_id: "",
      search_query:''
    };

    // Merge initialFilters from props if provided
    const filters = props.initialFilters ? { ...initialFilters, ...props.initialFilters } : initialFilters;

    this.state = {
      filters,
      tableRecords: {
        tableHeaders: [],
        tableRows: {
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "visit_date",
          sort_order: "desc",
        },
      },
      formDataInEdit: {},
      activeEditId: null,
      isModelOpen: false,
      isAddPatientModelOpen: false,
      detailViewId: null,
      isDetailViewOpen: false,
      organization_id: "",
      filterOpen: false,
      clinicOptions: [],
      visitsAutoFillData: {},
      visitDetailViewId: null,
      isVisitDetailViewOpen: false,
      activeLabId: null,
      isLabModelOpen: false,
      isPhysicalModelOpen: false,
      isFollowUpModelOpen: false,
      followUpClinicId: null,
      snapClinicConsentForm: null,
      snapVisitConsentForm: null,
      snapEmployeeDetails: null,
      selectedAllRecords: false,
      Tab: [
        { label: "Active", isActive: true, name: "Active" },
        { label: "Discharged", isActive: false, name: "Complete & Discharged" },
        { label: "All", isActive: false, name: "" },
        { label: "Interface", isActive: false, name: "In Active" },
        { label: "Cancelled", isActive: false, name: "Cancelled" },
      ],
      scheduledType: [
        { label: "All", isActive: true, name: "ALL" },
        { label: "Scheduled", isActive: false, name: "true" },
        { label: "Walk In", isActive: false, name: "false" },
      ],
      isMiniPopupOpen: false,
      billingStatusModalOpen: false,
      selectedVisitId: null,
      selectedVisitStatus: null,
      scanBarcodeModalOpen: false,
      autoEmployeeFillData: {},
      filterParam: null,
      showAuthorizationTreatmentModal: false,
      savedVisit:{},
      showIncidentModal: false,
      selectedVisitIdForIncident: null,
      selectedVisitCategoryForIncident: null,
      selectedBodyPart: [],
      sendTaskModalOpen: false,
      selectedVisitNavigationLink: null,
      daisyBillDocumentModalOpen: false,
      selectedBillForDocument: null,
      selectedVisitInfoForDocument: null,
      successfulBills: [], // Store all successful bills for sequential document upload
      currentBillIndex: 0, // Track which bill we're currently showing
      showPatientFormModal: false,
      selectedVisitForPatientForm: null,
      patientFormModalForKiosk: false,
      showKioskPinSetupModal: false,
      pendingKioskVisit: null,
      showAuditLogModal: false,
      selectedAuditVisitId: null,
      auditSearchQuery: "",
      auditSearchInputValue: "",
      auditActionFilter: "all",
      auditDateFilter: "all-time",
      expandedAuditItems: {},
      auditLogEntries: [],
      auditLogLoading: false,
      auditPage: 1,
      auditPerPage: 25,
      auditTotalPages: 1,
      auditTotalRecords: 0,
      auditUserSuggestions: [],
      selectedAuditUserId: null,
      showAuditUserSuggestions: false,
      showAiAuditModal: false,
      selectedAiAuditVisitId: null,
      showTranscriptionModal: false,
      transcriptionVisitId: null,
      transcriptionVisitData: null,
    };
  }
  componentDidMount() {
    this.fetchVisitsList();
    this.fetchClinicOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isModelOpen !== this.props.isModelOpen) {
      this.addVisitToogleHandler();
    }
    if (prevProps.visitsAutoFillData !== this.props.visitsAutoFillData) {
      this.setState({ visitsAutoFillData: this.props.visitsAutoFillData });
    }
    // console.log('prevsetate Filter',prevState.filterParam ,'CuurentFilter=>',filterFromParams);
    if (prevProps.globalFilter.Visits !== this.props?.globalFilter?.Visits) {
      this.fetchVisitsList();
    }

  }

  componentWillUnmount() {
    document.body.classList.remove("filterOpened");
    // Code to run before the component is unmounted
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addVisitToogleHandler = (visitData = false) => {
    let updatedState = { ...this.state };
    
    // If visitData is provided (visit object), pre-fill patient data
    if (visitData && typeof visitData === 'object' && (visitData.employee_id || visitData.employee?.employee_id)) {
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {
          company_id: visitData.company_id || '',
          employee_id: visitData.employee_id || visitData.employee?.employee_id || '',
          organization_id: OrganizationService.getOrgId(),
        },
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    } else if (visitData === true) {
      // Handle boolean flag for empty auto fill data (backward compatibility)
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {},
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    } else {
      // Default: just toggle modal without pre-filling
      updatedState = {
        ...updatedState,
        ["isModelOpen"]: !this.state.isModelOpen,
      };
    }
    
    this.setState(updatedState);
  };
  scanBarcodeHandler = (obj = {}, isAddEmployee = false) => {
    this.setState({
      scanBarcodeModalOpen: !this.state.scanBarcodeModalOpen,
      autoEmployeeFillData: obj,
      isAddPatientModelOpen: isAddEmployee,
    });
  };
  showModalHandler = () => {
    this.props.navigate("/visits/emr-details/null/visits");
  };
  addNewEmployeeToogleHandler = (
    bool = false,
    nextStep = null,
    autoFillData
  ) => {
    if (nextStep === "ADD_VISIT") {
      this.setState(
        {
          visitsAutoFillData: autoFillData,
          isAddPatientModelOpen: bool,
          addEmployeeAutoFillData: {},
        },
        this.addVisitToogleHandler()
      );
    } else {
      this.setState({
        isAddPatientModelOpen: bool,
        addEmployeeAutoFillData: {},
      });
    }
  };
  fetchClinicOptions = async (val = null) => {
    try {
      const response = await DropDownService.getClinicList(val);

      const clinicOptions = [{ label: "-Select Clinic-", value: "" }];

      if (Array.isArray(response)) {
        response.forEach((clinic) => {
          clinicOptions.push({
            label: clinic.name,
            value: clinic.clinic_id,
          });
        });
      } else if (response?.message === "Unauthenticated.") {
        // handle unauthenticated case
        console.warn("User not authenticated. Redirecting to login...");
        // example: window.location.href = "/login";
      } else {
        console.error("Unexpected response format:", response);
      }

      this.setState({ clinicOptions });
    } catch (error) {
      console.error("Error fetching clinic options:", error);
      this.setState({
        clinicOptions: [{ label: "Error fetching clinics", value: "" }],
      });
    }
  };

  openMiniPopup = (visitId, visitStatus) => {
    // const { top, left, width } = event.currentTarget.getBoundingClientRect();
    // const popupWidth = 200; // Adjust as needed
    this.setState({
      isMiniPopupOpen: true,
      // popupPosition: {
      //   top: top + window.scrollY + 30, // Offset to place below the button
      //   left: left + window.scrollX + width / 2 - popupWidth / 2 // Center the popup horizontally relative to the button
      // },
      selectedVisitStatus: visitStatus,
      selectedVisitId: visitId,
    });
  };
  billingStatusHandler = (visit_id = null) => {
    this.setState({
      billingStatusModalOpen: !this.state.billingStatusModalOpen,
      selectedVisitId: visit_id,
    });
  };
  closeMiniPopup = () => {
    this.setState({
      isMiniPopupOpen: false,
      selectedVisitId: null,
      selectedVisitStatus: null,
    });
  };

  clearAutoEmployeeFillData = () => {
    this.setState({
      autoEmployeeFillData: {}, // Reset auto employee data
    });
  };

  auditLogModalHandler = (visitId = null) => {
    const isOpening = !this.state.showAuditLogModal;
    if (isOpening) {
      this.setState(
        {
          showAuditLogModal: true,
          selectedAuditVisitId: visitId,
          auditSearchQuery: "",
          auditSearchInputValue: "",
          auditUserSuggestions: [],
          selectedAuditUserId: null,
          showAuditUserSuggestions: false,
          auditActionFilter: "all",
          auditDateFilter: "all-time",
          expandedAuditItems: {},
          auditLogEntries: [],
          auditPage: 1,
          auditPerPage: 25,
          auditTotalPages: 1,
          auditTotalRecords: 0,
        },
        () => this.fetchVisitAuditLogs(visitId)
      );
      return;
    }

    this.setState({
      showAuditLogModal: false,
      selectedAuditVisitId: null,
      auditSearchQuery: "",
      auditSearchInputValue: "",
      auditUserSuggestions: [],
      selectedAuditUserId: null,
      showAuditUserSuggestions: false,
      auditActionFilter: "all",
      auditDateFilter: "all-time",
      expandedAuditItems: {},
      auditLogEntries: [],
      auditLogLoading: false,
      auditPage: 1,
      auditPerPage: 25,
      auditTotalPages: 1,
      auditTotalRecords: 0,
    });
  };

  toggleAuditItem = (itemId) => {
    this.setState((prevState) => ({
      expandedAuditItems: {
        ...prevState.expandedAuditItems,
        [itemId]: !prevState.expandedAuditItems[itemId],
      },
    }));
  };

  aiAuditModalHandler = (visitId = null) => {
    if (visitId != null) {
      this.setState({
        showAiAuditModal: true,
        selectedAiAuditVisitId: visitId,
      });
      return;
    }
    this.setState({
      showAiAuditModal: false,
      selectedAiAuditVisitId: null,
    });
  };

  getRelativeDateLabel = (dateValue) => {
    if (!dateValue) {
      return "";
    }
    const now = new Date();
    const date = new Date(dateValue);
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const diffInDays = Math.floor((startOfToday - startOfDate) / 86400000);
    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    return "";
  };

  formatJsonForBlock = (value) => {
    if (value === null || value === undefined || value === "") {
      return "{}";
    }
    if (typeof value === "string") {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    }
    if (typeof value === "object") {
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  };

  humanizeModelType = (value = "") => {
    const text = String(value || "").trim();
    if (!text) return "Unknown";
    return text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  mapActionToUiMeta = (action = "") => {
    const normalized = String(action || "").toUpperCase();
    if (normalized === "CREATE") {
      return {
        actionType: "note-added",
        badgeIconClass: "fa-regular fa-note-sticky me-1",
        badgeLabel: "Create",
      };
    }
    if (normalized === "DELETE") {
      return {
        actionType: "other",
        badgeIconClass: "fa-solid fa-trash me-1",
        badgeLabel: "Delete",
      };
    }
    return {
      actionType: "field-update",
      badgeIconClass: "fa-solid fa-pen-to-square me-1",
      badgeLabel: "Update",
    };
  };

  getDateRangeForAuditFilter = (filterKey) => {
    const now = new Date();
    const formatMDY = (dateObj) => {
      const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
      const dd = String(dateObj.getDate()).padStart(2, "0");
      const yyyy = dateObj.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday.getTime() - 86400000);
    const startOfLast7Days = new Date(startOfToday.getTime() - 6 * 86400000);
    const startOfLast30Days = new Date(startOfToday.getTime() - 29 * 86400000);
    if (filterKey === "today") {
      const d = formatMDY(startOfToday);
      return { date_from: d, date_to: d };
    }
    if (filterKey === "yesterday") {
      const d = formatMDY(startOfYesterday);
      return { date_from: d, date_to: d };
    }
    if (filterKey === "last-7-days") {
      return { date_from: formatMDY(startOfLast7Days), date_to: formatMDY(now) };
    }
    if (filterKey === "last-30-days") {
      return { date_from: formatMDY(startOfLast30Days), date_to: formatMDY(now) };
    }
    return {};
  };

  fetchVisitAuditLogs = async (visitIdParam) => {
    const visitId = visitIdParam != null ? visitIdParam : this.state.selectedAuditVisitId;
    if (!visitId) return;
    const {
      auditPage,
      auditPerPage,
      auditSearchQuery,
      auditActionFilter,
      auditDateFilter,
      selectedAuditUserId,
    } = this.state;
    this.setState({ auditLogLoading: true });
    this.props.Loader?.(true);
    try {
      const dateRangeQuery = this.getDateRangeForAuditFilter(auditDateFilter);
      const actionQuery =
        auditActionFilter && auditActionFilter !== "all"
          ? { action: String(auditActionFilter).toLowerCase() }
          : {};
      const query = {
        page: auditPage,
        perPage: auditPerPage,
        visit_id: visitId,
        ...(auditSearchQuery?.trim() ? { search_query: auditSearchQuery.trim() } : {}),
        ...(selectedAuditUserId ? { user_id: selectedAuditUserId } : {}),
        ...actionQuery,
        ...dateRangeQuery,
      };
      const response = await AuditLogService.getAuditLogList(query);
      const apiRows = response?.data?.data || [];
      const pagination = response?.data?.pagination || response?.pagination || {};
      const userSuggestionsMap = new Map();
      const mappedRows = apiRows.map((row, index) => {
        const { actionType, badgeIconClass, badgeLabel } = this.mapActionToUiMeta(
          row?.action
        );
        const timestamp = row?.updated_at || row?.created_at;
        const dateObj = timestamp ? new Date(timestamp) : null;
        const timestampMs = dateObj ? dateObj.getTime() : null;
        const time = dateObj
          ? dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
          : "-";
        const date = dateObj
          ? dateObj.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          : "-";
        const actionLabel = this.humanizeModelType(row?.model_type_name || row?.model_type);
        const modelTypeName = row?.model_type_name || row?.model_type || "";
        const actionRaw = String(row?.action || "").toUpperCase();
        const oldJson = this.formatJsonForBlock(row?.original_data);
        const newJson = this.formatJsonForBlock(row?.changed_data);
        const updatedBy =
          row?.username ||
          `${row?.updated_by?.first_name || ""} ${row?.updated_by?.last_name || ""}`.trim() ||
          "System";
        const updatedById = row?.updated_by?.id || row?.user_id || row?.updated_by_id || null;
        if (updatedById && updatedBy && updatedBy !== "System") {
          const suggestionId = String(updatedById);
          if (!userSuggestionsMap.has(suggestionId)) {
            userSuggestionsMap.set(suggestionId, { id: suggestionId, name: updatedBy });
          }
        }

        const rawId = row?.id || `audit-${Math.random().toString(36).slice(2)}`;
        const safeId = String(rawId).replace(/[^a-zA-Z0-9_-]/g, "");
        const collapseId = `auditItem-${index + 1}-${safeId}`;

        return {
          id: collapseId,
          actionType,
          itemClass: "status-change",
          time,
          date,
          relative: this.getRelativeDateLabel(timestamp),
          user: updatedBy,
          modelTypeName,
          actionRaw,
          badgeLabel,
          badgeIconClass,
          actionLabel,
          oldJson,
          newJson,
          updatedBy,
          dataSearch: `${updatedBy} ${modelTypeName} ${actionRaw}`.toLowerCase(),
          timestampMs,
        };
      });

      this.setState({
        auditLogEntries: mappedRows,
        auditUserSuggestions: Array.from(userSuggestionsMap.values()),
        expandedAuditItems: {},
        auditTotalPages: Number(pagination?.total_pages || 1),
        auditTotalRecords: Number(pagination?.totalCount ?? mappedRows.length ?? 0),
      });
    } catch (error) {
      this.setState({
        auditLogEntries: [],
        auditTotalPages: 1,
        auditTotalRecords: 0,
      });
      this.props.Toast?.error("Failed to load audit logs");
    } finally {
      this.setState({ auditLogLoading: false });
      this.props.Loader?.(false);
    }
  };

  getAuditLogPaginationMeta = () => {
    const { auditPage, auditPerPage, auditTotalRecords, auditTotalPages } = this.state;
    const totalPages = Math.max(
      1,
      Number(auditTotalPages) > 0
        ? Number(auditTotalPages)
        : Math.ceil((auditTotalRecords || 0) / Math.max(1, auditPerPage || 25)) || 1
    );
    const maxVisible = 5;
    const current = auditPage;
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(1, current - half);
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    const visiblePages = [];
    for (let i = start; i <= end; i++) {
      visiblePages.push(i);
    }
    return { totalPages, visiblePages };
  };

  handleAuditPageNavigate = (page) => {
    const { totalPages } = this.getAuditLogPaginationMeta();
    if (
      this.state.auditLogLoading ||
      page < 1 ||
      page > totalPages ||
      page === this.state.auditPage
    ) {
      return;
    }
    this.setState({ auditPage: page }, () => this.fetchVisitAuditLogs());
  };

  handleAuditPerPageSelect = (value) => {
    if (this.state.auditPerPage === value || this.state.auditLogLoading) {
      return;
    }
    this.setState({ auditPerPage: value, auditPage: 1 }, () =>
      this.fetchVisitAuditLogs()
    );
  };

  handleAuditSearchInputChange = (e) => {
    const nextValue = e.target.value;
    this.setState(
      {
        auditSearchInputValue: nextValue,
        selectedAuditUserId: null,
        showAuditUserSuggestions: true,
      },
      () => this.fetchAuditUserSuggestions(nextValue)
    );
  };

  handleAuditSearchFocus = () => {
    this.setState({ showAuditUserSuggestions: true }, () =>
      this.fetchAuditUserSuggestions(this.state.auditSearchInputValue)
    );
  };

  handleAuditSearchBlur = () => {
    // Keep delay so suggestion clicks can register before dropdown closes
    setTimeout(() => {
      this.setState({ showAuditUserSuggestions: false });
    }, 150);
  };

  handleAuditUserSuggestionSelect = (user) => {
    this.setState(
      {
        auditSearchInputValue: user.name,
        auditSearchQuery: user.name,
        selectedAuditUserId: user.id,
        auditPage: 1,
        showAuditUserSuggestions: false,
      },
      () => this.fetchVisitAuditLogs()
    );
  };

  fetchAuditUserSuggestions = async (searchText = "") => {
    try {
      const query = {
        search: searchText,
        ...(this.state.selectedAuditVisitId ? { visit_id: this.state.selectedAuditVisitId } : {}),
      };
      const response = await AuditLogService.getAuditLogUsers(query);
      const rawUsers = response?.data || response || [];
      const suggestions = Array.isArray(rawUsers)
        ? rawUsers.map((item) => ({
            id: item?.id,
            name:
              item?.name ||
              `${item?.first_name || ""} ${item?.last_name || ""}`.trim(),
          }))
        : [];
      this.setState({ auditUserSuggestions: suggestions.filter((user) => user.id && user.name) });
    } catch (error) {
      this.setState({ auditUserSuggestions: [] });
    }
  };

  submitAuditSearch = () => {
    if (this.state.auditLogLoading) {
      return;
    }

    this.setState(
      (prevState) => ({
        auditSearchQuery: prevState.auditSearchInputValue,
        selectedAuditUserId: (() => {
          const selectedUser = prevState.auditUserSuggestions.find(
            (user) => String(user.id) === String(prevState.selectedAuditUserId)
          );
          return selectedUser && selectedUser.name === prevState.auditSearchInputValue
            ? prevState.selectedAuditUserId
            : null;
        })(),
        auditPage: 1,
        showAuditUserSuggestions: false,
      }),
      () => this.fetchVisitAuditLogs()
    );
  };

  handleAuditSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.submitAuditSearch();
    }
  };

  render() {
    const { params } = this.props;
    const {
      tableRecords,
      isModelOpen,
      isAddPatientModelOpen,
      visitCategoryOptions,
      isDetailViewOpen,
      visitsAutoFillData,
      detailViewId,
      isVisitDetailViewOpen,
      visitDetailViewId,
      isLabModelOpen,
      snapEmployeeDetails,
      Tab,
      filters,
      scheduledType,
      isFollowUpModelOpen,
      followUpClinicId,
      isPhysicalModelOpen,
      isMiniPopupOpen,
      selectedVisitId,
      selectedVisitStatus,
      selectedAllRecords,
      autoEmployeeFillData,
      billingStatusModalOpen,
      showAuthorizationTreatmentModal,
      savedVisit,
      showIncidentModal,
      selectedVisitIdForIncident,
      selectedBodyPart,
      sendTaskModalOpen,
      selectedVisitNavigationLink,
      daisyBillDocumentModalOpen,
      selectedBillForDocument,
      selectedVisitInfoForDocument,
      successfulBills,
      showPatientFormModal,
      selectedVisitForPatientForm,
      showKioskPinSetupModal,
      showAuditLogModal,
      auditActionFilter,
      auditDateFilter,
      expandedAuditItems,
      auditLogEntries,
      auditLogLoading,
      auditPage,
      auditPerPage,
      auditTotalRecords,
      showAiAuditModal,
      selectedAiAuditVisitId,
      showTranscriptionModal,
      transcriptionVisitId,
      transcriptionVisitData,
    } = this.state;
    /* Audit log search bar hidden: normalizedAuditInput / filteredAuditUserSuggestions were only for the search input + dropdown
    const normalizedAuditInput = String(auditSearchInputValue || "").trim().toLowerCase();
    const filteredAuditUserSuggestions = auditUserSuggestions
      .filter((user) =>
        normalizedAuditInput === ""
          ? true
          : String(user?.name || "").toLowerCase().includes(normalizedAuditInput)
      )
      .slice(0, 10);
    */
    const auditPaginationNav =
      showAuditLogModal && auditTotalRecords > 0
        ? this.getAuditLogPaginationMeta()
        : null;
    const isPatientHistory =
      isSet(params.patientId, null) !== null ? true : false;
    // Add a GlobalSearchFilter paths
     const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/employee",
    ];
    const { profile, location } = this.props;
    const { pathname } = location;
    return (
      <>
        {isAddPatientModelOpen ? (
          <AddEmployee
            modelTitle={"Add Employee"}
            isFromVisitHistory={this.props.isFromVisitHistory}
            fetchEmployeeList={this.fetchVisitsList}
            isOpen={isAddPatientModelOpen}
            autoEmployeeFillData={autoEmployeeFillData}
            modalToogleHandler={this.addNewEmployeeToogleHandler}
            clearAutoEmployeeFillData={this.clearAutoEmployeeFillData}
          />
        ) : isModelOpen ? (
          <AddVisits
            modelTitle={"Add Visits"}
            fetchVisitsList={this.fetchVisitsList}
            isOpen={isModelOpen}
            autoFillData={visitsAutoFillData}
            modalToogleHandler={this.addVisitToogleHandler}
            visitCategoryOptions={visitCategoryOptions}
          />
        ) : isDetailViewOpen ? (
          <EmployeeDetails
            modalToogleHandler={this.detailViewModal}
            fetchEmployeeList={() => {}}
            employeeId={detailViewId}
          />
        ) : (
          <></>
        )}
        {isVisitDetailViewOpen ? (
          <VisitDetails
            isOpen={isVisitDetailViewOpen}
            visitId={visitDetailViewId}
            modalToogleHandler={this.visitDetailViewModal}
            fetchDetails={this.fetchVisitsList}
            snapEmployeeDetails={snapEmployeeDetails}
          />
        ) : (
          ""
        )}
        {isMiniPopupOpen && (
          <MiniPopup
            isOpen={isMiniPopupOpen}
            onClose={this.closeMiniPopup}
            onUpdate={this.handleUpdateStatus}
            visitId={selectedVisitId}
            fetchVisitsList={this.fetchVisitsList}
            selectedVisitStatus={selectedVisitStatus}
            totalRecords={this.state.tableRecords.pagination.totalRecords}
          />
        )}
        {billingStatusModalOpen ? (
          <UpdateBillingStatusModal
            isOpen={billingStatusModalOpen}
            visitId={selectedVisitId}
            fetchRecords={this.fetchVisitsList}
            modalToogleHandler={this.billingStatusHandler}
          />
        ) : (
          <></>
        )}
        {isLabModelOpen ? (
          <AddLab
            modelTitle={"Add Lab"}
            isOpen={isLabModelOpen}
            visitId={visitDetailViewId}
            modalToogleHandler={this.addLabToogleHandler}
            fetchRecords={this.fetchVisitsList}
          />
        ) : (
          ""
        )}
        {showAuthorizationTreatmentModal && (
          <AddAuthorizationTreatment
            isOpen={showAuthorizationTreatmentModal}
            authorizationToogleHandler={(val) => this.authorizationHandler(val)}
            visitId={selectedVisitId}
            popupData={true}
            savedVisit={savedVisit}
            employeeDetails={snapEmployeeDetails}
            profile={this.props.profile}
          />
          )}
        {showIncidentModal && (
          <AddIncidentModal
            incidentToogleHandler={this.incidentModalHandler}
            isOpen={showIncidentModal}
            visitId={selectedVisitIdForIncident}
            employeeDetails={snapEmployeeDetails}
            isEdit={true}
            isFromIncidentList={true}
            selectedBodyPart={selectedBodyPart}
            setSelectedBodyPart={(val) => this.setState({ selectedBodyPart: val })}
            visitCategory={this.state.selectedVisitCategoryForIncident}
          />
        )}
        {isFollowUpModelOpen ? (
          <AddFollowUp
            modelTitle={"Follow Up"}
            visitId={visitDetailViewId}
            clinicId={followUpClinicId}
            isOpen={isFollowUpModelOpen}
            modalToogleHandler={this.followUpModelHandler}
            fetchRecords={this.fetchVisitsList}
          />
        ) : (
          ""
        )}
        {isPhysicalModelOpen ? (
          <AddPhysical
            modelTitle={"Add Physical / Drug Screen"}
            isOpen={isPhysicalModelOpen}
            visit_id={visitDetailViewId}
            fetchRecords={this.fetchVisitsList}
            modalToogleHandler={this.addPhysicalToogleHandler}
          />
        ) : (
          ""
        )}
        {sendTaskModalOpen && (
          <SendTaskModal
            isOpen={sendTaskModalOpen}
            modalToogleHandler={() => this.setState({ sendTaskModalOpen: false, selectedVisitNavigationLink: null })}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            navigationLink={selectedVisitNavigationLink}
          />
        )}
        {/* Daisy Bill Document Upload Modal - commented out, auto-upload chart note used instead */}
        {/* {this.state.daisyBillDocumentModalOpen && selectedBillForDocument && (
          <DaisyBillDocumentUploadModal
            isOpen={this.state.daisyBillDocumentModalOpen}
            modalToogleHandler={this.handleDaisyBillDocumentModalClose}
            billId={selectedBillForDocument}
            visitInfo={this.state.selectedVisitInfoForDocument}
            onSuccess={this.handleDaisyBillDocumentModalClose}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
          />
        )} */}
        {this.state.scanBarcodeModalOpen && (
          <ScanbarCodePopup modleToogleHandler={this.scanBarcodeHandler} />
        )}
        <KioskPinSetupModal
          isOpen={showKioskPinSetupModal}
          onClose={this.kioskPinSetupClose}
          onSuccess={this.kioskPinSetupSuccess}
          Toast={this.props.Toast}
        />
        {showPatientFormModal && selectedVisitForPatientForm && (
          <PatientFormModelWithHoc
            isOpen={showPatientFormModal}
            visitId={selectedVisitForPatientForm.visit_id}
            visitData={selectedVisitForPatientForm}
            modalToogleHandler={this.patientFormModalClose}
            visitCategory={selectedVisitForPatientForm.visit_category}
            forKiosk={this.state.patientFormModalForKiosk}
            services={[]}
            contractService={selectedVisitForPatientForm.standard_service?.physical_name || selectedVisitForPatientForm.standard_services}
            activityList={[]}
            physicalServices={[]}
          />
        )}
        {showAuditLogModal && (
          <div
            className="modal fade show"
            id="auditlogscreen"
            tabIndex="-1"
            aria-labelledby="auditlogscreenmodal"
            style={{ display: "block" }}
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-scrollable hResponsive modal-dialog-centered modal-xl">
              <div className="modal-content h-100">
                <div
                  className="sh_modalBox d-flex flex-column h-100 overflow-hidden"
                  style={{ backgroundColor: "#fff", minHeight: 0 }}
                >
                  <div className="modal-header  border-0 pb-0">
                    <div className="d-flex flex-column">
                      <h5 className="modal-title font-weight-bold mb-0" id="auditlogscreenmodal">Audit Log</h5>
                    </div>
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => this.auditLogModalHandler(null)}></button>
                  </div>
                  <div className="modal-header d-flex flex-wrap align-items-center gap-3 pb-3">
                    <div className="d-flex w-50 align-items-center gap-3">
                      {/* Audit log popup: search field + user suggestions + Search button (disabled in UI; handlers/state unchanged)
                      <div className="form-group w-75 mr-2 mb-0 position-relative">
                        <input
                          id="auditSearchInput"
                          type="text"
                          className="form-control border-start-0"
                          placeholder="Search audit logs..."
                          autoComplete="off"
                          value={auditSearchInputValue}
                          onChange={this.handleAuditSearchInputChange}
                          onKeyDown={this.handleAuditSearchKeyDown}
                          onFocus={this.handleAuditSearchFocus}
                          onBlur={this.handleAuditSearchBlur}
                        />
                        {showAuditUserSuggestions && filteredAuditUserSuggestions.length > 0 && (
                          <div
                            className="list-group position-absolute w-100"
                            style={{ zIndex: 20, maxHeight: "220px", overflowY: "auto" }}
                          >
                            {filteredAuditUserSuggestions.map((user) => (
                              <button
                                key={user.id}
                                type="button"
                                className="list-group-item list-group-item-action text-left"
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  this.handleAuditUserSuggestionSelect(user);
                                }}
                              >
                                {user.name}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.submitAuditSearch}
                        disabled={auditLogLoading && auditSearchInputValue === auditSearchQuery}
                      >
                        Search
                      </button>
                      */}

                      <select
                        id="auditActionFilter"
                        className="form-control w-25 form-control-solid"
                        aria-label="Action filter"
                        value={auditActionFilter}
                        onChange={(e) =>
                          this.setState({ auditActionFilter: e.target.value, auditPage: 1 }, () =>
                            this.fetchVisitAuditLogs()
                          )
                        }
                      >
                        <option value="all">All actions</option>
                        <option value="CREATE">Create</option>
                        <option value="UPDATE">Update</option>
                        <option value="DELETE">Delete</option>
                      </select>
                    </div>
                    <div className="">
                      <select
                        id="auditDateFilter"
                        className="form-control  form-control-solid"
                        aria-label="Date filter"
                        value={auditDateFilter}
                        onChange={(e) =>
                          this.setState({ auditDateFilter: e.target.value, auditPage: 1 }, () =>
                            this.fetchVisitAuditLogs()
                          )
                        }
                      >
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="last-7-days">Last 7 days</option>
                        <option value="last-30-days">Last 30 days</option>
                        <option value="all-time">All time</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="modal-body pt-0 overflow-auto flex-grow-1 position-relative"
                    style={{ minHeight: 0 }}
                  >
                    <div className="sh_auditlog">
                      <div id="auditTimeline" className="sh_auditlog-timeline">
                        {auditLogEntries.map((entry) => {
                          const isOpen = !!expandedAuditItems[entry.id];
                          return (
                            <div key={entry.id} className={`sh_auditlog-item ${entry.itemClass || entry.actionType}`} data-action={entry.actionType} data-search={entry.dataSearch}>
                              <div className="sh_auditlog-left">
                                <div className="sh_auditlog-time">{entry.time}</div>
                                <div className="sh_auditlog-date">{entry.date}</div>
                                <div className="sh_auditlog-relative">{entry.relative}</div>
                              </div>

                              <div className="sh_auditlog-card">
                                <a
                                  className="sh_auditlog-toggle"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#${entry.id}`}
                                  aria-expanded={isOpen}
                                  aria-controls={entry.id}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.toggleAuditItem(entry.id);
                                  }}
                                >
                                  <div className="d-flex justify-content-between sh_auditlog-toggle-container">
                                    <div className="sh_auditlog-toggle-left">
                                      <div className="sh_auditlog-user">
                                        <i className="fa-solid fa-circle-user"></i>
                                        <span>{entry.user}</span>
                                      </div>
                                      <span className="badge rounded-pill sh_auditlog-badge">
                                        <i className={entry.badgeIconClass}></i> {entry.badgeLabel}
                                      </span>
                                    </div>
                                    <div className="sh_auditlog-toggle-right">
                                      <span className="sh_auditlog-action">{entry.actionLabel}</span>
                                    </div>
                                  </div>
                                </a>

                                <div id={entry.id} className={`collapse${isOpen ? " show" : ""}`}>
                                  <div className="sh_auditlog-body">
                                    {entry.field ? (
                                      <div className="sh_auditlog-change">
                                        <div className="sh_auditlog-field">{entry.field}</div>
                                        <div className="sh_auditlog-chip sh_auditlog-chip-old">{entry.oldValue}</div>
                                        <div className="sh_auditlog-sep" aria-hidden="true">
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                                          </svg>
                                        </div>
                                        <div className="sh_auditlog-chip sh_auditlog-chip-new">{entry.newValue}</div>
                                      </div>
                                    ) : (
                                      <div className="sh_auditlog-json-wrap">
                                        <div className="sh_auditlog-json-section">
                                          <div className="sh_auditlog-json-label sh_auditlog-json-old">Old JSON data</div>
                                          <pre className="sh_auditlog-json-block sh_auditlog-json-block-old"><code>{entry.oldJson}</code></pre>
                                        </div>
                                        <div className="sh_auditlog-json-section">
                                          <div className="sh_auditlog-json-label sh_auditlog-json-new">Changed JSON data</div>
                                          <pre className="sh_auditlog-json-block sh_auditlog-json-block-new"><code>{entry.newJson}</code></pre>
                                        </div>
                                      </div>
                                    )}

                                    <div className="sh_auditlog-meta">
                                      <span>Updated by {entry.updatedBy}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        <div className={`sh_auditlog-empty ${auditLogEntries.length === 0 ? "" : "d-none"}`} id="auditEmptyState">
                          <div className="text-center py-5">
                            <div className="fw-semibold">{auditLogLoading ? "Loading audit entries..." : "No audit entries found"}</div>
                            <div className="text-muted small">Try adjusting your search or filters.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {auditPaginationNav && (
                    <div className="modal-footer flex-shrink-0 p-0 border-top bg-white">
                      <div className="d-flex justify-content-between align-items-center mt-1 sh_cardFooter sh_cardbglight sh_pagination w-100 mb-0 px-3 py-2">
                        <div className="d-flex align-items-center">
                          <span className="text-sm mr-2">Showing</span>
                          <div className="dropdown">
                            <button
                              className="btn bg-white input-group-text mr-2 dropdown-toggle text-sm"
                              type="button"
                              id="visitAuditLogPerPageDropdown"
                              data-bs-toggle="dropdown"
                              disabled={auditLogLoading}
                            >
                              {auditPerPage}
                            </button>
                            <div
                              className="dropdown-menu text-sm"
                              aria-labelledby="visitAuditLogPerPageDropdown"
                            >
                              {[10, 25, 50, 100].map((v) => (
                                <button
                                  key={v}
                                  type="button"
                                  className={`dropdown-item ${
                                    auditPerPage === v ? "selected" : ""
                                  }`}
                                  onClick={() => this.handleAuditPerPageSelect(v)}
                                >
                                  {v}
                                </button>
                              ))}
                            </div>
                          </div>
                          <span className="text-sm">of {auditTotalRecords} items</span>
                        </div>

                        <div className="d-flex align-items-center">
                          <ul
                            className={`sh_paginationbox mb-1 d-flex list-unstyled${
                              auditLogLoading ? " pe-none opacity-50" : ""
                            }`}
                          >
                            {auditPage !== 1 && (
                              <li className="page-item cursor-pointer">
                                <a
                                  aria-label="First"
                                  title="Go to First Page"
                                  className="page-link"
                                  onClick={() => this.handleAuditPageNavigate(1)}
                                >
                                  <span aria-hidden="true">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="#023292"
                                    >
                                      <path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z"></path>
                                    </svg>
                                  </span>
                                </a>
                              </li>
                            )}

                            {auditPage !== 1 && (
                              <li className="page-item cursor-pointer">
                                <a
                                  aria-label="Previous"
                                  title="Go to Previous Page"
                                  className="page-link"
                                  onClick={() =>
                                    this.handleAuditPageNavigate(auditPage - 1)
                                  }
                                >
                                  <span aria-hidden="true">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="#023292"
                                    >
                                      <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"></path>
                                    </svg>
                                  </span>
                                </a>
                              </li>
                            )}

                            {auditPaginationNav.visiblePages.map((pageNum) => (
                              <li
                                key={pageNum}
                                className={`page-item cursor-pointer ${
                                  pageNum === auditPage ? "active" : ""
                                }`}
                              >
                                <a
                                  className="page-link action_bg"
                                  title={`Go to Page ${pageNum}`}
                                  onClick={() => this.handleAuditPageNavigate(pageNum)}
                                >
                                  {pageNum}
                                </a>
                              </li>
                            ))}

                            {auditPage !== auditPaginationNav.totalPages && (
                              <li className="page-item cursor-pointer">
                                <a
                                  aria-label="Next"
                                  title="Go to Next Page"
                                  className="page-link"
                                  onClick={() =>
                                    this.handleAuditPageNavigate(auditPage + 1)
                                  }
                                >
                                  <span aria-hidden="true">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="#023292"
                                    >
                                      <path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                                    </svg>
                                  </span>
                                </a>
                              </li>
                            )}

                            {auditPage !== auditPaginationNav.totalPages && (
                              <li className="page-item cursor-pointer">
                                <a
                                  aria-label="Last"
                                  title="Go to Last Page"
                                  className="page-link"
                                  onClick={() =>
                                    this.handleAuditPageNavigate(
                                      auditPaginationNav.totalPages
                                    )
                                  }
                                >
                                  <span aria-hidden="true">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="#023292"
                                    >
                                      <path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                                    </svg>
                                  </span>
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
        {showAuditLogModal && <div className="modal-backdrop fade show"></div>}
        <VisitAiAuditModal
          isOpen={showAiAuditModal && !!selectedAiAuditVisitId}
          visitId={selectedAiAuditVisitId}
          onClose={() => this.aiAuditModalHandler(null)}
          Toast={this.props.Toast}
        />


        <TranscriptionRecordingModal
          isOpen={showTranscriptionModal && !!transcriptionVisitId}
          visitId={transcriptionVisitId}
          visitData={transcriptionVisitData}
          profile={this.props.profile}
          onClose={this.closeTranscriptionModal}
          Toast={this.props.Toast}
          Loader={this.props.Loader}
        />
       
        <div className="sh_cardBox sh_maincardht position-realtive shvl-mobile-patient-list">
           <div className="sh_cardHeader pb-0">
            <div className="d-flex position-relative w-100 shvl-visits-title-search-row flex-wrap align-items-center justify-content-between gap-2">
                  <h2 className="h2-strong position-absolute sh_welcome-text  sh_welcome-text mb-0">Visits List</h2>
                   {!isPatientHistory && profile &&
            profile.is_multiple_organization === false &&
            profile.employee_login === false &&
            globalSearchFilter.some((path) => pathname.startsWith(path)) && (
            <GlobalSearch
                activeMenu={"Visits"}
                pathname={pathname}
            />
        )}
              </div>
            </div>
          {!isPatientHistory ? (
            <div className="pb-0">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex w-100 flex-column">
                  <div className="d-flex justify-content-between align-items-center">
                    {/* <h2 className="h2-strong">Visits</h2> */}
                    <div className="d-flex gap-2">
                      {/* <span className="">
                        <Buttons
                          iconType="NewQrIcon"
                          clickHandler={this.scanBarcodeHandler}
                          className="btn btn-light sh_btnlight"
                          acl={"employee-create"}
                          label={"Scan barcode"}
                        />
                      </span>
                      <span className="">
                        <Buttons
                          iconType="NewAddVisitIcon"
                          clickHandler={this.addVisitToogleHandler}
                          className="btn btn-primary sh_btnprimary"
                          acl={"visits-create"}
                          // appendAddIcon={true}
                          label={"Add New Visit"}
                        />
                      </span>

                      <span className="">
                        <Buttons
                          iconType="NewAddPatientIcon"
                          clickHandler={() =>
                            this.addNewEmployeeToogleHandler(true)
                          }
                          className="btn btn-primary sh_btnprimary"
                          acl={"employee-create"}
                          // appendAddIcon={true}
                          label={"Add Patient"}
                        />
                      </span> */}
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* <div className="sh_cardBody sh_cardbglight pt-0 my-1"> */}
            {!isPatientHistory ? (
              <div className="d-flex sh_cardHeader flex-column w-100 mt-0 sh_cardbglight rounded-top shvl-mobile-toolbar">
                <div className="d-flex justify-content-between border-bottom shvl-mobile-tab-row">
                  <div className="tabs_wrapForTable ">
                    <ul className="nav nav-borders nav-tabs border-0" role="">
                      {Tab.map((itm, itmInd) => {
                        return (
                          <>
                            <li>
                              <a
                                className={`flex-sm-fill text-sm-center nav-link ${
                                  itm.isActive ? "active" : ""
                                }`}
                                aria-current="page"
                                onClick={() => this.setActiveTab(itm)}
                              >
                                {itm.label}
                              </a>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="d-flex gap-2 shvl-mobile-actions-row">
                    <span className="">
                        <Buttons
                          iconType="NewQrIcon"
                          clickHandler={this.scanBarcodeHandler}
                          className="btn btn-light sh_btnlight rsp-icon-only-btn"
                          acl={PERMISSIONS.VISITS.SCAN_BARCODE}
                          accessType="Hide"
                          label={" Scan barcode"}
                          title="Scan barcode"
                        />
                      </span>
                      <span className="">
                        <Buttons
                          iconType="NewAddVisitIcon"
                          clickHandler={this.addVisitToogleHandler}
                          className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                          acl={PERMISSIONS.VISITS.CREATE}
                          // accessType="Hide"
                          // appendAddIcon={true}
                          label={"  Add New Visit"}
                          title="Add New Visit"
                        />
                      </span>

                      <span className="">
                        <Buttons
                          iconType="NewAddPatientIcon"
                          clickHandler={() =>
                            this.addNewEmployeeToogleHandler(true)
                          }
                          className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                          acl={PERMISSIONS.EMPLOYEE.CREATE}
                          // accessType="Hide"
                          // appendAddIcon={true}
                          label={"  Add Patient"}
                          title="Add Patient"
                        />
                      </span>
                  <FormInputs
                    type="SelectList"
                    value={filters["clinic_id"]}
                    changeHandler={(val) => {
                      this.onChangeFiltersHandler("clinic_id", val);
                     // this.fetchVisitsList(filters);
                    }}
                    options={this.state.clinicOptions}
                    className="form-control mr-2 mb-1 sh_visitsListClinicSelect"
                  />
                  </div>
                </div>

                <div className="d-flex justify-content-between my-1 shvl-mobile-filter-row">
                   <div
                      className="d-flex align-items-center ml-2"
                      style={{ gap: "10px", justifyContent: "flex-start" }}
                    >
   
                    <FormInputs
                       type='TextInput'
                       className="form-control form-control-solid"
                       placeholder="Search"
                       value={filters["search_query"]}
                       changeHandler={(val) => {
                      this.onChangeFiltersHandler("search_query", val);
                     // this.fetchVisitsList(filters);
                    }}
                    />
                      {/* Label on the left */}
                      {/* <label htmlFor="showTodayAndFutureToggle" className="text-sm mb-0">
                        Scheduled Visits
                      </label> */}

                      {/* Toggle switch */}
                      {/* <label className="switch">
                        <input
                          type="checkbox"
                          id="showTodayAndFutureToggle"
                          name="showTodayAndFuture"
                          checked={!!this.props.showScheduledVisits}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            this.props.setShowScheduledVisits(isChecked);
                            
                            // Show toast notification based on toggle state
                            if (isChecked) {
                              this.props.Toast.success("Showing Today and Future visits");
                            } else {
                              this.props.Toast.success("Showing Overall Visits");
                            }
                            
                            // Fetch visits list with the new filter value
                            this.fetchVisitsList({ showScheduledVisits: isChecked });
                          }}
                        />
                        <span className="slider sh_emrststus"></span>
                      </label> */}
                    </div>
             
                  <div>
                    <div className="tabs_wrapForTable">
                      <div className="nav sh_subnav border-0">
                        {scheduledType.map((itm, itmInd) => (
                          <label
                            key={itmInd}
                            className={`flex-sm-fill text-sm-center text-dark  nav-link ${
                              itm.isActive ? "active" : ""
                            }`}
                            style={{ cursor: "pointer" }}
                          >
                            <FormInputs
                              type="Radio"
                              name="scheduleType"
                              value={itm.isActive}
                              checked={itm.isActive}
                              changeHandler={() => this.setActiveScheduled(itm)}
                              style={{ display: "none" }} // hide default radio
                            />
                            <span className="name font-weight-bold">
                              {itm.label}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

            <TableGrid
              hasPagination={true}
              fetchTableRecords={(filters) => this.fetchVisitsList(filters)}
              hasHeaderAction={true} //headerProps
              needCardBody={false}
              customClass="shvl-visits-mobile-table"
              headersProps={{
                tableRecords: tableRecords,
                headerButtons: this.getHeaderButtons(),
                checkBoxchangeHandler: this.checkBoxchangeHandler,
                selectedAllRecords: selectedAllRecords,
                setSelectedAllRecords: (bool) =>
                  this.setState({ selectedAllRecords: bool }),
              }}
              {...tableRecords}
              gridEditProps={{
                formDataInEdit: this.state.formDataInEdit,
                activeEditId: this.state.activeEditId,
                onChangeFormDataInEdit: this.onChangeFormDataInEdit,
              }}
            />
          {/* </div> */}
          {/* <div className="sh_cardFooter sh_cardbglight sh_pagination">
            <div>
              <label className="text-sm">Showing 1-10 of 30 items</label>
            </div>
            <div className="d-flex align-items-center">
              <ul className="sh_paginationbox mb-1">
                <li className="page-item">
                  <a aria-label="First" className="page-link" href="#">
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>

                <li className="page-item">
                  <a aria-label="Previous" className="page-link" href="#">
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>

                <li className="page-item active">
                  <a className="page-link action_bg" href="#">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link action_bg" href="#">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link action_bg" href="#">
                    4
                  </a>
                </li>

                <li className="page-item">
                  <a aria-label="Next" className="page-link" href="#">
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>

                <li className="page-item">
                  <a aria-label="Last" className="page-link" href="#">
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </>
    );
  }
  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      ...filters,
    };
    await this.fetchVisitsList(queryfilters);
  };
  clearFiltersHandler = async () => {
    this.setState(
      {
        filters: {
          first_name: "",
          last_name: "",
          gender: "",
          company_id: "",
          dob: "",
          visit_status: "",
          patient_id: "",
          phone: "",
          patient_id: "",
          identification_type: "",
          identification_number: "",
          clinic_id: "",
          booking_id: "",
          pre_registration_code: "",
          clinic_location_id: "",
          employee_id: "",
        },
      },
      this.submitFiltersHandler
    );
  };
  authorizationHandler = (val=false,visit=null,visit_id=null, employee=null) => {
    
    this.setState({
      showAuthorizationTreatmentModal: val,
      selectedVisitId: visit_id,
      snapEmployeeDetails: employee,
      savedVisit: visit,visit
    })
  }

  sendTaskModalHandler = (navigationLink = null) => {
    this.setState({
      sendTaskModalOpen: true,
      selectedVisitNavigationLink: navigationLink,
    });
  };

  patientFormResendHandler = async (visit) => {
    const { Loader, Toast } = this.props;
    try {
      Loader(true);
      const visitData = await VisitsService.getVisits(visit.visit_id);
      const fullVisit = visitData?.[0];
      if (!fullVisit) {
        Toast.error("Unable to load visit details");
        return;
      }
      this.setState({
        showPatientFormModal: true,
        selectedVisitForPatientForm: fullVisit,
        patientFormModalForKiosk: false,
      });
    } catch (error) {
      console.error("Error fetching visit for patient forms:", error);
      Toast.error("Unable to load visit details");
    } finally {
      Loader(false);
    }
  };

  /** Same as Resend Patient Forms, but modal submit opens in kiosk mode. */
  patientFormsKioskHandler = async (visit) => {
    const { Loader, Toast, dispatch } = this.props;
    try {
      Loader(true);
      const freshProfile = await UserService.getUserProfile();
      if (freshProfile?.id) {
        dispatch(setProfileDetails({ key: freshProfile.id, value: freshProfile }));
      }
      if (!freshProfile?.kiosk_mode_enabled) {
        Toast.error("Kiosk patient forms are not enabled for your role.");
        return;
      }
      const visitData = await VisitsService.getVisits(visit.visit_id);
      const fullVisit = visitData?.[0];
      if (!fullVisit) {
        Toast.error("Unable to load visit details");
        return;
      }
      if (!freshProfile?.has_kiosk_pin) {
        this.setState({
          showKioskPinSetupModal: true,
          pendingKioskVisit: fullVisit,
          patientFormModalForKiosk: true,
        });
        return;
      }
      this.setState({
        showPatientFormModal: true,
        selectedVisitForPatientForm: fullVisit,
        patientFormModalForKiosk: true,
      });
    } catch (error) {
      console.error("Error fetching visit for kiosk patient forms:", error);
      Toast.error("Unable to load visit details");
    } finally {
      Loader(false);
    }
  };

  kioskPinSetupClose = () => {
    this.setState({
      showKioskPinSetupModal: false,
      pendingKioskVisit: null,
      patientFormModalForKiosk: false,
    });
  };

  kioskPinSetupSuccess = async () => {
    const { Loader, Toast, dispatch } = this.props;
    try {
      Loader(true);
      const freshProfile = await UserService.getUserProfile();
      if (freshProfile?.id) {
        dispatch(setProfileDetails({ key: freshProfile.id, value: freshProfile }));
      }
      const pending = this.state.pendingKioskVisit;
      this.setState({
        showKioskPinSetupModal: false,
        pendingKioskVisit: null,
        showPatientFormModal: true,
        selectedVisitForPatientForm: pending,
        patientFormModalForKiosk: true,
      });
    } catch (e) {
      Toast.error("Unable to refresh profile after saving PIN.");
    } finally {
      Loader(false);
    }
  };

  patientFormModalClose = () => {
    this.setState(
      {
        showPatientFormModal: false,
        selectedVisitForPatientForm: null,
        patientFormModalForKiosk: false,
        showKioskPinSetupModal: false,
        pendingKioskVisit: null,
      },
      () => this.fetchVisitsList()
    );
  };

  incidentModalHandler = async (visitId = null, employeeDetails = null) => {
    const wasOpen = this.state.showIncidentModal;
    let visitCategory = null;
    
    // Fetch visit category if visitId is provided
    if (visitId && !wasOpen) {
      try {
        const visitData = await VisitsService.getVisits(visitId);
        if (visitData && visitData[0]) {
          visitCategory = visitData[0].visit_category;
        }
      } catch (error) {
        console.error("Error fetching visit category:", error);
      }
    }
    
    this.setState({
      showIncidentModal: !this.state.showIncidentModal,
      selectedVisitIdForIncident: visitId,
      selectedVisitCategoryForIncident: visitCategory || this.state.selectedVisitCategoryForIncident,
      snapEmployeeDetails: employeeDetails || this.state.snapEmployeeDetails,
    }, () => {
      // Refresh the visits list when modal closes
      if (wasOpen) {
        this.fetchVisitsList();
      }
    });
  }
  fetchVisitsList = async (query = {}, Loader = true) => {
    const { Tab } = this.state;
    const { tableRecords } = this.state;
    const { params, activeIds, selectedAllRecords, showScheduledVisits } = this.props;
    const { filters } = this.state;
    const globalFilter = this.props?.globalFilter?.Visits || {};

    let queryString = toQueryString({
      ...tableRecords.pagination,
      ...query,
    });
    queryString = { ...filters, ...queryString, ...globalFilter };
    
    // Use showScheduledVisits from query if provided (for immediate updates), otherwise use props
    // const shouldFilterScheduled = query.showScheduledVisits !== undefined 
    //   ? query.showScheduledVisits 
    //   : showScheduledVisits;
    
    // // Add filter for today and future visits if toggle is checked
    // if (shouldFilterScheduled) {
    //   const today = getCurrentDate(); // Format: MM/DD/YYYY
    //   queryString.visit_from = today; // Filter visits from today onwards
    // }
    // When unchecked, leave visit_from as-is from globalFilter so user's "Visit From" is still sent
    try {
      this.props.Loader(Loader);
      let VisitsList = {};
      if (params.patientId) {
        VisitsList = await EmployeeService.getEmployeeVisitsHistoryList(
          params.patientId,
          queryString
        );
      } else {
        const activeTab = Tab.find((itm) => itm.isActive == true);

        if (
          isSet(query.visit_status) &&
          query.visit_status !== activeTab.name
        ) {
          this.setState({
            Tab: [
              { label: "Active", isActive: true, name: "Active" },
              {
                label: "Discharged",
                isActive: false,
                name: "Complete & Discharged",
              },
              { label: "All", isActive: false, name: "" },
              { label: "Interface", isActive: false, name: "In Active" },
              { label: "Cancelled", isActive: false, name: "Cancelled" },
            ],
          });
          // query = { ...query, ['visit_status']: query.visit_status  }
        } else {
          query = { ...query, ["visit_status"]: activeTab?.name ?? "" };
        }
        VisitsList = await VisitsService.getVisitsList(queryString);
      }
      if (!VisitsList) {
        this.setState((prevState) => ({
          tableRecords: {
            ...prevState.tableRecords,
            tableHeaders: this.getTableHeader(),
            tableRows: { type: "default", data: [] },
            pagination: {
              ...prevState.tableRecords.pagination,
              ...query,
              totalRecords: 0,
            },
          },
        }));
        this.props.Loader();
        return;
      }
      const visitRows = Array.isArray(VisitsList?.data?.data)
        ? VisitsList.data.data
        : Array.isArray(VisitsList?.data)
          ? VisitsList.data
          : [];
      let tableData = [];
      let activeRowCnt = 0;
      visitRows.forEach((visit) => {
        // const usDateTimeString = moment.utc(employee.created_at).format('MMMM D, YYYY h:mm:ss A');
        // console.log('visit',visit);
        // Use screen_type if available, otherwise fall back to visit_category
        const categoryForRedirect = visit.screen_type || visit.visit_category;
        const voiceProgressRow = voiceDocProgressFromVisitListRow(visit);
        const voiceUi = getVoiceToolbarUi(voiceProgressRow);
        // Employer portal: deny opening chart for Work Comp visits.
        const isWorkCompVisit = isWorkCompVisitCategory(categoryForRedirect);
        const denyWorkCompChartForEmployerInLoop =
          this.props?.profile?.employer_login && isWorkCompVisit;

        const hyperLink = denyWorkCompChartForEmployerInLoop
          ? {}
          : isSet(params.patientId, null !== null)
          ? isWorkCompVisitCategory(categoryForRedirect)
            ? {
                href: `/visits/emr-details/${visit.visit_id}/visits`,
                title: "Patient Visit EMR view",
              }
            : {
                href: `/employee/visit-history/${params.patientId}/${params.patientDetails}/${visit.visit_id}`,
                title: "Patient Visit detailed view",
              }
          : isWorkCompVisitCategory(categoryForRedirect)
          ? {
              href: `/visits/emr-details/${visit.visit_id}/visits`,
              title: "Patient Visit EMR view",
            }
          : {
              href: "/visits/visit-details/" + visit.visit_id,
              title: "Patient Visit detailed view",
            };
        let activeRow = false;
        if (selectedAllRecords || activeIds.includes(visit.visit_id)) {
          activeRow = true;
          activeRowCnt++;
        }
      // 1. Create the base dropdown list
        // Don't add base dropdown items if employer_login is true
        let meatballDropdownList = [];
        if (!this.props.profile?.employer_login) {
          meatballDropdownList = [
            // {
            //   className: "btn btn-icon px-1 btn-transparent-dark",
            //   // iconType: "NewLabsIcon",
            //   iconType: "Labs Order",
            //   title: "Add Lab",
            //   label: "Add Lab",
            //   acl: `${
            //     isLaboratoryVisitCategory(visit.visit_category)
            //       ? PERMISSIONS.RESULT.CREATE
            //       : ""
            //   }`,
            //   disableButtonTitle: "Add Lab",
            //   clickHandler: () => this.props.navigate(hyperLink.href),
            // },
            // {
            //   className: "btn btn-icon btn-transparent-dark",
            //   // iconType: "NewAddPhysicalIcon",
            //   iconType: "AddPhysical",
            //   label: "Add Physical or Drug Screen",
            //   disableButtonTitle: "Add Physical and Drug Screen",
            //   acl: isLaboratoryVisitCategory(visit.visit_category)
            //     ? ""
            //     : visit.has_physical
            //     ? ""
            //     : "any",
            //   title: "Add Physical or Drug Screen",
            //   clickHandler: () =>
            //     this.addPhysicalToogleHandler(
            //       visit.visit_id,
            //       visit.company_id
            //     ),
            // },
            ...([
              "Employer Services - Physicals",
              "Employer Services - Labs",
              "Employer Services - Drug Screens",
              "Employer Services - Vaccines",
              "Employer Services - DOT Physicals"
            ].includes(visit.visit_category)
              ? [
                  {
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Print",
                    label: "Download Clearance Report",
                    title: "Download Clearance Report",
                    acl: PERMISSIONS.VISITS.DOWNLOAD_CLEARANCE_REPORT,
                    clickHandler: () =>
                      this.printClearanceReport(visit.visit_id),
                  },
                ]
              : []),
          ];
        }

        // Determine which dropdown to use based on screenType
        // Check screenType from props first, then from globalFilter
        const globalFilter = this.props?.globalFilter?.Visits || {};
        const screenType = this.props.screenType || globalFilter.screenType;
        const denyWorkCompChartForEmployer =
          this.props.profile?.employer_login && isWorkCompVisit;
        let currentMeatballDropdownList = meatballDropdownList;
        
        if (screenType === 'workComp') {
          // For Work Comp screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Print",
            label: "Work Status",
            title: "Work Status",
            clickHandler: () => this.printWorkStatusReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "New Appointment",
              title: "Add Visit",
              clickHandler: () => this.addVisitToogleHandler(visit)
            },
            {
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Search",
            label: "View Incident",
            title: "View Incident",
            clickHandler: () => this.incidentModalHandler(visit.visit_id, visit.employee)
            },
          ];
        }

        if (screenType === 'physicals') {
          // For Work Comp screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Clearance Report",
              title: "Clearance Report",
              clickHandler: () =>
                this.printClearanceReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "New Appointment",
              title: "Add Visit",
              clickHandler: () => this.addVisitToogleHandler(visit)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
                iconType: "Print",
                label: "Compliance",
                title: "Compliance",
                },
          ];
        }

        if (screenType === 'employerPhysicals') {
          // For Employer Admin Physicals screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Clearance Report",
              title: "Clearance Report",
              clickHandler: () =>
                this.printClearanceReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              label: "Charting Page List",
              title: "Chart",
              clickHandler: () => this.props.navigate(hyperLink.href),
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              label: "Go To Patient ",
              title: "Patient Details",
              clickHandler: () => {
                if (visit.employee && visit.employee_id) {
                  const patientParams = encryptString({
                    patientName: `${visit.employee.first_name || ''} ${visit.employee.last_name || ''} ${visit.employee.dob || ''}`,
                    company_id: visit.company_id || '',
                    company_assigned: visit.company_assigned || '',
                    employee_id: visit.employee_id,
                  });
                  // Always navigate to employer-employee visit history
                  this.props.navigate(`/employer-employee/visit-history/${visit.employee_id}/${patientParams}`);
                }
              },
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Export List",
              title: "Export List",
              acl: "any",
              clickHandler: () => {
                // TODO: Implement export functionality
                console.log("Export List clicked for visit:", visit.visit_id);
              }
            },
          ];
        }

        if (screenType === 'employerDrugScreen') {
          // For Employer Admin Physicals screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "View Results",
              title: "Chart",
              clickHandler: () => this.navigateToVisitDetails(visit.visit_id, visit.employee_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              label: "Go To Patient ",
              title: "Patient Details",
              clickHandler: () => {
                if (visit.employee && visit.employee_id) {
                  const patientParams = encryptString({
                    patientName: `${visit.employee.first_name || ''} ${visit.employee.last_name || ''} ${visit.employee.dob || ''}`,
                    company_id: visit.company_id || '',
                    company_assigned: visit.company_assigned || '',
                    employee_id: visit.employee_id,
                  });
                  // Always navigate to employer-employee visit history
                  this.props.navigate(`/employer-employee/visit-history/${visit.employee_id}/${patientParams}`);
                }
              },
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Export List",
              title: "Export List",
              acl: "any",
              clickHandler: () => {
                // TODO: Implement export functionality
                console.log("Export List clicked for visit:", visit.visit_id);
              }
            },
          ];
        }

        if (screenType === 'employerVaccines') {
          // For Employer Admin Physicals screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "View Results",
              title: "Chart",
              clickHandler: () => this.navigateToVisitDetails(visit.visit_id, visit.employee_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              label: "Go To Patient ",
              title: "Patient Details",
              clickHandler: () => {
                if (visit.employee && visit.employee_id) {
                  const patientParams = encryptString({
                    patientName: `${visit.employee.first_name || ''} ${visit.employee.last_name || ''} ${visit.employee.dob || ''}`,
                    company_id: visit.company_id || '',
                    company_assigned: visit.company_assigned || '',
                    employee_id: visit.employee_id,
                  });
                  // Always navigate to employer-employee visit history
                  this.props.navigate(`/employer-employee/visit-history/${visit.employee_id}/${patientParams}`);
                }
              },
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Export List",
              title: "Export List",
              acl: "any",
              clickHandler: () => {
                // TODO: Implement export functionality
                console.log("Export List clicked for visit:", visit.visit_id);
              }
            },
          ];
        }

        if (screenType === 'drugscreen') {
          // For Drug Screen screen, use a specialized dropdown
          currentMeatballDropdownList = [
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Search",
              label: "View Results",
              title: "View Results",
              clickHandler: () => this.navigateToVisitDetails(visit.visit_id, visit.employee_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Print Results",
              title: "Print Results",
              clickHandler: () => this.printClearanceReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "New Appointment",
              title: "Add Visit",
              clickHandler: () => this.addVisitToogleHandler(visit)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Compliance",
              title: "Compliance",
              clickHandler: () => {}
            },
          ];
        }
        

        if(screenType === 'visithistory'){
          currentMeatballDropdownList = [
           {
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Print",
            label: "Work Status",
            title: "Work Status",
            clickHandler: () => this.printWorkStatusReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Clearance Report",
              title: "Clearance Report",
              clickHandler: () =>
                this.printClearanceReport(visit.visit_id)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Result",
              title: "Print Lab Report",
              // clickHandler: () => this.openLabPrintMenu(visit, "lab_report")
            }, 
            {
              className: "btn btn-icon btn-transparent-dark",
              iconType: "AddIconDetailView",
              label: "New Appointment",
              title: "Add Visit",
              clickHandler: () => this.addVisitToogleHandler(visit)
            },
            {
              className: "btn btn-icon btn-transparent-dark",
                iconType: "Print",
                label: "Compliance",
                title: "Compliance",
                },
          ];
        }

        const allowedPrintCategories = [
          "Employer Services - Physicals",
          "Employer Services - DOT Physicals",
          "Employer Services - Drug Screens",
          "Work Comp - New Injury",
        ];
        if(this.props.profile?.employer_login===true){
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Search",
            label: "Authorization Form",
            title: "Authorization Form",
            clickHandler: () =>
              this.authorizationHandler(true,visit,visit.visit_id, visit.employee),
          });
        }

        // Conditionally add the print buttons for specific visit categories
        if (!this.props.profile?.employer_login===true && allowedPrintCategories.includes(visit.visit_category)) {
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Print",
            label: "Print Intake Paperwork",
            title: "Print Intake Paperwork",
            acl: PERMISSIONS.VISITS.PRINT_INTAKE_PAPERWORK,
            clickHandler: () =>
              this.printIntakeHandler(
                visit.visit_id,
                visit.visit_category,
                visit.employee
              ),
          });

          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "ConsentFormIcon",
            label: "Print Consents",
            title: "Print Consents",
            acl: PERMISSIONS.VISITS.PRINT_CONSENTS,
            clickHandler: () =>
              this.printConsentHandler(visit.visit_id, "Consent Form"),
          });

          // For Work Comp visits, add Print ChartNote options after Print Consents
          if (
            [
              "Work Comp - New Injury",
              "Work Comp - Other",
              "Work Comp - Follow Up",
            ].includes(visit.visit_category)
          ) {
            currentMeatballDropdownList.push({
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Print ChartNote",
              title: "Print ChartNote",
              acl: PERMISSIONS.VISITS.PRINT_CHARTNOTE,
              clickHandler: () => this.printChartNoteHandler(visit.visit_id),
            });
            currentMeatballDropdownList.push({
              className: "btn btn-icon btn-transparent-dark",
              iconType: "Print",
              label: "Print Edited ChartNote",
              title: "Print Edited ChartNote",
              acl: PERMISSIONS.VISITS.PRINT_EDITED_CHARTNOTE,
              clickHandler: () => this.printEditedChartNoteHandler(visit.visit_id),
            });
          }
        }

        // Add Submit to Daisy Bill option for Work Comp visits
        if (
          visit.visit_category === "Work Comp - New Injury" ||
          visit.visit_category === "Work Comp - Follow Up" ||
          visit.visit_category === "Work Comp - Physical Therapy"
        ) {
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Email",
            label: "Submit to Daisy Bill",
            title: "Submit to Daisy Bill",
            acl: PERMISSIONS.VISITS.SUBMIT_TO_DAISY_BILL,
            clickHandler: () => this.bulkSubmitToDaisyBill([visit.visit_id]),
          });
        }

        // Add Resend Patient Forms option to all meatball dropdowns
        currentMeatballDropdownList.push({
          className: "btn btn-icon btn-transparent-dark",
          iconType: "ChatSquareTextFill",
          iconColor: "#8F909E",
          label: "Resend Patient Forms",
          title: "Resend Patient Forms",
          acl: PERMISSIONS.VISITS.RESEND_PATIENT_FORMS,
          clickHandler: () => this.patientFormResendHandler(visit),
        });

        if (this.props.profile?.kiosk_mode_enabled) {
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "QrCode",
            iconColor: "#8F909E",
            label: "Patient Forms in Kiosk Mode",
            title: "Patient Forms in Kiosk Mode",
            acl: PERMISSIONS.VISITS.PATIENT_FORMS_KIOSK,
            clickHandler: () => this.patientFormsKioskHandler(visit),
          });
        }

        // Add Send Message option to all meatball dropdowns
        currentMeatballDropdownList.push({
          className: "btn btn-icon btn-transparent-dark",
          iconType:"Phone",
          label: "Send Message",
          title: "Send Message",
          acl: PERMISSIONS.VISITS.SEND_MESSAGE,
          clickHandler: () => this.sendTaskModalHandler(hyperLink.href),
        });



        // Keep delete action in dropdown below Send Message
        currentMeatballDropdownList.push({
          className: "btn btn-icon btn-transparent-dark",
          iconType: "Remove",
          label: "Delete",
          title: "Delete",
          acl: "visits-delete",
          isDelete: true,
          contentTitle: visit.has_physical ? "Warning" : null,
          content: visit.has_physical
            ? "This visit has some associated activities.  Are you sure you want to delete this record?"
            : null,
          clickHandler: () => this.deleteHandler(visit.visit_id),
        });
        //  this.props?.profile?.permissions, PERMISSIONS.AUDIT_LOG.LIST
        // if (this.props?.profile?.internal_audit_enabled) {

        const canShowAuditLog = acl_check(
          this.props?.profile?.permissions,
          PERMISSIONS.AUDIT_LOG.LIST
        );

        if (canShowAuditLog) {
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "AuditLog",
            label: "Audit Log",
            title: "Audit Log",
            acl: "any",
            clickHandler: () => this.auditLogModalHandler(visit.visit_id),
          });
        }

        const canShowAiAudit = acl_check(
          this.props?.profile?.permissions,
          PERMISSIONS.AI_DIAGNOSIS_LOGS.LIST
        );

        if (canShowAiAudit) {
          currentMeatballDropdownList.push({
            className: "btn btn-icon btn-transparent-dark",
            iconType: "AuditLog",
            label: "AI Audit",
            title: "AI Audit",
            acl: "any",
            clickHandler: () => this.aiAuditModalHandler(visit.visit_id),
          });
        }

        tableData = [
          ...tableData,
          {
            employeeIndex: 0,
            isHeading: false,
            rowId: visit.visit_id,
            data: {
              ...visit,
              _original_visit_category: visit.visit_category, // Preserve original for filtering
              isActive: activeRow,
              // employee_name: [
              //   {
              //     className: "text-sm d-flex align-items-center gap-1",
              //     acl: "any",
              //     label: (
              //       <div className="d-flex align-items-center gap-1">
              //         {/* Initials Avatar */}
              //         <div 
              //         className="img-profile rounded-circle"
              //           style={{
              //             width: "32px",
              //             height: "32px",
              //             borderRadius: "50%",
              //             backgroundColor: "#023292", // or random color
              //             color: "#fff",
              //             display: "flex",
              //             alignItems: "center",
              //             justifyContent: "center",
              //             fontWeight: "bold",
              //             fontSize: "14px",
              //           }}
              //         >
              //           {visit.employee.first_name.charAt(0).toUpperCase()}
              //           {visit.employee.last_name.charAt(0).toUpperCase()}
              //         </div>

              //         {/* Full Name */}
              //         <span
              //           onClick={() => this.detailViewModal(visit.employee_id)}
              //           style={{ cursor: "pointer" }}
              //         >
              //           {visit.employee.first_name + " " + visit.employee.last_name}
              //         </span>
              //       </div>
              //     ),
              //   },
              // ],
              provider_name: {
                value: visit?.primary_provider 
                  ? `${visit.primary_provider.first_name || ''} ${visit.primary_provider.last_name || ''}`.trim() 
                  : '-',
                ...hyperLink,
              },
              employee_name: [
                {
                  className: "text-sm d-flex align-items-center gap-1",
                  acl: "any",
                                    label:visit.employee.first_name + ' ' + visit.employee.last_name,
                  clickHandler: () =>this.detailViewModal(visit.employee_id)  
                },
              ],

              clinic: {
                value: visit?.employee?.clinic?.name,
                ...hyperLink,
              },
              company: { value: visit?.company?.name, ...hyperLink },
              visit_date: {
                value: visit.visit_date,
                ...hyperLink,
              },
              visit_category: {
                value: getShortenedVisitCategoryName(visit.visit_category),
                ...hyperLink,
              },
              status: {
                value: (
                  <a className="px-1" title={visit.overall_status}>
                    <Icons
                      fontSize={"15px"}
                      // type={`New${getOverAllStatusIcon(visit?.overall_status)}`}
                      type={`${getOverAllStatusIcon(visit?.overall_status)}`}
                    />
                  </a>
                ),
              },
              visit_status: {
                value: visit.visit_status,
                className: "text-sm",
                label: visit.visit_status,
                acl: "any",
                title: "Update Status",
                clickHandler: (e) =>
                  this.openMiniPopup(visit.visit_id, visit.visit_status),
              },
              billing_status: {
                className: "btn btn-icon btn-transparent-dark ml-2  ",
                // iconType: "NewBillingTableIcon",
                iconType: "Billing",
                acl: PERMISSIONS.VISITS.EDIT,
                disable: visit?.billing_status == "Billed",
                iconSize: 23,
                iconColor: getBillingStatusColor(visit?.billing_status),
                title: "Billing",
                disableButtonTitle: "Billed",
                billing_value: visit?.billing_status,
                value: visit.billing_status,
              },
              visit_time: { value: visit.visit_time, ...hyperLink },
              visit_reason: { value: visit.visit_reason, ...hyperLink },
              formatted_los_time: {
                value: (() => {
                  const isAutoDischarged = visit.current_los_time > 1 && visit.visit_status === 'Complete & Discharged';
                  return isAutoDischarged 
                    ? (
                        <>
                          {visit.formatted_los_time}{' '}
                          <span style={{ color: '#dc3545' }}>*</span>
                        </>
                      )
                    : visit.formatted_los_time;
                })(),
                ...hyperLink,
              },
              record_id:{
                  value: visit.record_id?visit.record_id:'N/A',
                ...hyperLink,
              },
              created_at: visit.created_at,
              updated_at: visit.updated_at,
              // registration: { value: 'In clinic', ...hyperLink },
              // createdAt:usDateTimeString,//employee.created_at,
              action: [
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewDetailViewIcon",
                  iconType: "Search",
                  label: "",
                  acl: "employee-edit",
                  title: "Detail view",
                  clickHandler: () =>
                    this.visitDetailViewModal(visit.visit_id, visit.employee),
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewChartIcon",
                  iconType: "ActivityChart",
                  iconSize: 15,
                  acl: denyWorkCompChartForEmployer
                    ? PERMISSIONS.NO_PERMISSION
                    : PERMISSIONS.VISITS.VIEW_CHART,
                  // accessType: "Hide",
                  title: "Chart",
                  href: hyperLink.href,
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  iconType: "NewFollowUpIcon",
                  acl: PERMISSIONS.VISITS.FOLLOW_UP,
                  title: "Follow Up",
                  label: "Add Follow-Up",
                  clickHandler: () =>
                    this.followUpModelHandler(
                      visit.visit_id,
                      visit?.assigned_clinic_id ||
                        visit?.assigned_clinic?.clinic_id ||
                        visit?.employee?.clinic_id
                    ),
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  iconType: `Question_${visit.questionnaires_status}`,
                  title:
                    visit.questionnaires_status === "Default"
                      ? "Questionnaires Not Available"
                      : visit.questionnaires_status === "Completed"
                      ? "Questionnaires are completed"
                      : visit.questionnaires_status === "Sent"
                      ? "Questionnaires are already sent"
                      : visit.questionnaires_status === "Available"
                      ? "Questionnaires are not sent yet"
                      : visit.questionnaires_status,
                  label: "",
                  acl: "employee-edit",
                  disabled: visit.questionnaires_status === "Default",
                  clickHandler: () => {
                    const blockedStatuses = ["Default", "Completed", "Sent"];
                    if (!blockedStatuses.includes(visit.questionnaires_status)) {
                      this.SendQuestionnaire(visit.visit_id);
                    }
                  },
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  iconType: voiceUi.iconType,
                  iconSize: 20,
                  acl: PERMISSIONS.VISITS.VIEW_CHART,
                  title: isVoiceTranscriptionListCategory(categoryForRedirect)
                    ? voiceUi.title
                    : "Transcription Not Available.",
                  label: "",
                  disabled: !isVoiceTranscriptionListCategory(categoryForRedirect),
                  clickHandler: () => {
                    if (!isVoiceTranscriptionListCategory(categoryForRedirect)) return;
                    this.openTranscriptionWorkflow(visit);
                  },
                },
                {      
                  // iconType:"NewMeatBallIcon",
                  iconType:"MeatBall",
                  title: "More",
                  // Use currentMeatballDropdownList based on screenType
                  iconDropDownList: currentMeatballDropdownList
               }
             ],
            },
          },
        ];
      });
      const allCheckbox = document.getElementById("ALL");
      if (allCheckbox) {
        allCheckbox.checked = false;
        if (tableData.length != 0 && activeRowCnt == tableData.length) {
          allCheckbox.checked = true;
        }
      }
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: this.getTableHeader(),
          tableRows: {
            type: "default",
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: VisitsList?.pagination?.totalCount ?? 0,
          },
        },
      }));

      this.props.Loader();
    } catch (e) {
      console.log(e);
      this.props.Loader();
    }
  };

  // Print ChartNote PDF (Work Comp visits) - Real chart note
  printChartNoteHandler = async (visitId) => {
    console.log('visitIdddd',visitId);
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const data = await PatientChartsService.getPrintChartNote(visitId);
      if (!data) {
        Toast.error("ChartNote not found");
        Loader(false);
        return;
      }
      const pdfData = {
        file_content: data,
        original_name: "ChartNote",
        mime_type: "application/pdf",
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.error("Error printing ChartNote:", e);
      Toast.error("Failed to print ChartNote");
    } finally {
      Loader(false);
    }
  };

  // Print Edited ChartNote PDF (Work Comp visits) - Edited chart note
  printEditedChartNoteHandler = async (visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const data = await PatientChartsService.getPrintEditedChartNote(visitId);
      if (!data) {
        Toast.error("Edited ChartNote not found");
        Loader(false);
        return;
      }
      const pdfData = {
        file_content: data,
        original_name: "EditedChartNote",
        mime_type: "application/pdf",
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.error("Error printing Edited ChartNote:", e);
      Toast.error("Failed to print Edited ChartNote");
    } finally {
      Loader(false);
    }
  };

  // Print Clearance Report PDF
  printClearanceReport = async (visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const data = await PatientChartsService.getClearanceReportPDF(null, visitId);
      if (!data) {
        Toast.error("Clearance Report Not Found");
        Loader(false);
        return;
      }
      const pdfData = {
        file_content: data,
        original_name: "clearance-report",
        mime_type: "application/pdf",
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.error("Error printing Clearance Report:", e);
      Toast.error("Error while fetching Clearance Report");
    } finally {
      Loader(false);
    }
  };

  // Print Work Status Report PDF
  printWorkStatusReport = async (visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const response = await EmrVisitsService.printWorkStatusForm(visitId);
      
      // Handle different response structures
      const base64Data = typeof response === 'string' ? response : (response?.data || response);
      
      if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
        const pdfData = {
          file_content: base64Data,
          original_name: "work-status-report",
          mime_type: "application/pdf"
        };
        FileManagerService.printPdf(pdfData);
      } else {
        console.error("Invalid PDF data received:", base64Data);
        Toast.error("Failed to generate work status report PDF");
      }
    } catch (e) {
      console.error("Error printing Work Status Report:", e);
      Toast.error("Error while fetching Work Status Report");
    } finally {
      Loader(false);
    }
  };

  // Print Lab Label/Report
  printlabel = async (labData, type, labelName = 'lab') => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const queryfilters = {
        label_type: type,
        visit_id: labData.visit_id || labData.visit?.visit_id,
      };
      
      let printData;
      const labId = labData.id;
      
      if (type === 'lab_report') {
        printData = await PatientChartsService.getLaboratoryReport(null, queryfilters, labId);
      } else if (type === 'lab_requisition') {
        printData = await PatientChartsService.getLabRequisition(null, queryfilters, labId);
      } else {
        printData = await PatientChartsService.getPrintLabel(null, queryfilters, labId);
      }
      
      if (!printData) {
        Toast.error(`${labelName} not found`);
        Loader(false);
        return;
      }
      
      const pdfData = {
        file_content: printData,
        original_name: `${labelName}`,
        mime_type: 'application/pdf'
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.error("Error printing label/report:", e);
      Toast.error(`Error while fetching ${labelName}`);
    } finally {
      Loader(false);
    }
  };

  // Open lab print menu - fetch labs for visit and print
  openLabPrintMenu = async (visit, printType) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      // Fetch labs for this visit
      const queryfilters = {
        visit_id: visit.visit_id,
        page: 1,
        perPage: 100, // Get all labs for this visit
      };
      
      const labsList = await EmployeeService.getAllEmployeeVisitLab(queryfilters);
      
      if (!labsList || !labsList.data || !labsList.data.data || labsList.data.data.length === 0) {
        Toast.error("No lab reports found for this visit");
        Loader(false);
        return;
      }
      
      // Get the first lab (or you could show a modal to select which lab to print)
      const labItem = labsList.data.data[0];
      
      // If there are multiple labs, use the first one
      // You could enhance this to show a modal for selection if needed
      if (labsList.data.data.length > 1) {
        console.log(`Multiple labs found (${labsList.data.data.length}), printing the first one`);
      }
      
      // Print the lab report using the printlabel function
      await this.printlabel(labItem, printType, 'lab_report');
      
    } catch (e) {
      console.error("Error printing lab report:", e);
      Toast.error("Error printing lab report");
    } finally {
      Loader(false);
    }
  };

  // Example usage
  getTableHeader = () => {
    return [
      {
        label: "",
        name: "ALL",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxchangeHandler,
      },
      // {
      //   label: "Status",
      //   name: "status",
      //   key: "status",
      // },
      {
        label: "Provider",
        type: "",
        key: "provider_name",
        sortName: "provider_name",
      },
      {
        label: "Patient",
        type: "Actions",
        key: "employee_name",
        sortName: "employee_name",
      },
      {
        label: "Visit Date",
        key: "visit_date",
        type: "",
        inputType: "Date",
        sortName: "visit_date",
      },
      {
        label: "Visit Time",
        key: "visit_time",
        type: "",
        sortName: "visit_time",
      },
      // {
      //   label: "Registration",
      //   key: "registration",
      //   type: "",
      // },
      // {
      //   label: "Clinic",
      //   key: "clinic",
      // },
      {
        label: "Company",
        key: "company",
      },

      {
        label: "Visit category",
        key: "visit_category",
        type: "",
        options: this.state.visitCategoryOptions,
        inputType: "SelectList",
        sortName: "visit_category",
      },
      {
        label: "Visit Status",
        key: "visit_status",
        type: "FieldEdit",
        options: this.props.visitStatus,
        inputType: "SelectList",
        sortName: "visit_status",
        onSave: this.updateFeildData,
        style: { minWidth: "120px" },
      },
      // {
      //   label: "Reason",
      //   key: "visit_reason",
      //   type: "",
      //   inputType: "TextArea",
      //   sortName: 'visit_reason'
      // }
      {
        label: "LOS",
        key: "formatted_los_time",
        type: "",
        inputType: "TextArea",
        sortName: "formatted_los_time",
      },
      // {
      //   key:"record_id",
      //   label: "Record Id",
      //   type: "",
      //   inputType: "TextArea",
      //   sortName: "record_id",
      // },
      {
        label: "Billing Status",
        key: "billing_status",
        type: "FieldEdit",
        options: this.props.billingStatus,
        isAction: true,
        inputType: "SelectList",
        sortName: "billing_status",
        onSave: this.updateFeildData,
        style: { minWidth: "100px" },
      },
      { label: "Action", key: "action", type: "Actions" },
      // Add more columns as needed
    ];
  };
  visitDetailViewModal = (
    visitId = null,
    snapEmployeeDetails = null,
    fetch = false
  ) => {
    if (fetch) {
      this.fetchVisitsList();
    }
    this.setState((oldState) => ({
      isVisitDetailViewOpen: !oldState.isVisitDetailViewOpen,
      visitDetailViewId: visitId,
      snapEmployeeDetails: snapEmployeeDetails,
    }));
  };
  deleteHandler = async (visitId, multipleDelete = false) => {
    if (multipleDelete) {
      visitId = getActiveIds(this.state.tableRecords);
    }
    try {
      await VisitsService.deleteVisits(visitId);
      this.props.Toast.success("Visit Deleted successfully");
      this.fetchVisitsList();
      // this.props.Toast.success('Employee Deleted Succesfully');
      //   }
    } catch (e) {}
  };
  updateFeildData = async (key, id, value) => {
    const payload = { [key]: value };
    let response;
    let validation = {};
    let succMsg = "Updated Successfully";
    if (key == "visit_status") {
      response = await VisitsService.updateVisitStatus(null, id, payload);
      succMsg = "Visit Status Updated Successfully ";
    }
    if (key == "billing_status") {
      response = await VisitsService.updateVisitBillingStatus(id, payload);
      succMsg = "Billing Status Updated Successfully ";
    }
    if (response.status && response.status == "ERROR") {
      if (isObject(response.data)) {
        for (let key in response.data) {
          validation = {
            ...validation,
            [key]: response.data[key].join(","),
          };
        }
      }
    } else {
      this.props.Toast.success(succMsg);
      this.fetchVisitsList({}, false);
    }
    return validation;
  };
  bulkDeleteHandler = async (visitIds) => {
    await VisitsService.deleteVisits(visitIds);
    this.props.clearCbState();
    this.props.Toast.success("Visit Deleted successfully");
    this.fetchVisitsList();
  };
  editHandler = (rowId, data) => {
    // console.log("rowId",rowId,"data",data);
    if (rowId == null) {
      this.setState({ activeEditId: "", formDataInEdit: {} });
      return false;
    }
    this.setState({
      activeEditId: rowId,
      formDataInEdit: data,
    });
  };
  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    let updatedFilters = { ...filters };
    if (key === "clinic_id") {
      updatedFilters["clinic_location_id"] = "";
    }
    this.setState(
      {
        filters: {
          ...updatedFilters,
          [key]: val,
        },
      },
      this.submitFiltersHandler
    );
  };
  updateHandler = async (visitId) => {
    const { formDataInEdit } = this.state;
    let payload = {
      visit_category: isObject(formDataInEdit.visit_category)
        ? formDataInEdit.visit_category.value
        : formDataInEdit.visit_category,
      visit_date: isObject(formDataInEdit.visit_date)
        ? formDataInEdit.visit_date.value
        : formDataInEdit.visit_date,
      visit_reason: isObject(formDataInEdit.visit_reason)
        ? formDataInEdit.visit_reason.value
        : formDataInEdit.visit_reason,
      visit_status: isObject(formDataInEdit.visit_status)
        ? formDataInEdit.visit_status.value
        : formDataInEdit.visit_status,
    };

    try {
      const res = await VisitsService.updateVisits(visitId, payload);
      if (res.code === 500) {
        this.props.Toast.error(isSet(res.data, "Something went wrong.."));
      } else if (res.status === "ERROR" && res.data) {
        if (isObject(res.data)) {
          let validaitons = {};
          for (let key in res.data) {
            validaitons = { ...validaitons, [key]: res.data[key][0] };
          }
          this.setState((prevState) => ({
            formDataInEdit: {
              ...prevState.formDataInEdit,
              validation: validaitons,
            },
          }));
        }
      } else {
        this.props.Toast.success("Employee/patient visit updated successfully");
        this.editHandler(null, {});
      }
      // console.log('data',data);
    } catch (e) {}
    this.fetchVisitsList();
  };
  addLabToogleHandler = (visitId = null) => {
    this.setState({
      isLabModelOpen: !this.state.isLabModelOpen,
      visitDetailViewId: visitId,
    });
  };
  checkBoxchangeHandler = (value, { e }, rowId = "") => {
    if (!rowId) {
      rowId = e.target.id;
    }
    const { tableRows } = this.state.tableRecords;
    let updatedData;
    let updateIds = [...new Set(this.props.activeIds)];

    if (rowId === "ALL") {
      updatedData = tableRows.data.map((item) => {
        item.data.isActive = value;
        return item;
      });

      if (value) {
        updateIds = [
          ...new Set([
            ...updateIds,
            ...tableRows.data.map((item) => item.rowId),
          ]),
        ];
      } else {
        updateIds = [];
      }
    } else {
      updatedData = tableRows.data.map((item) => {
        if (item.rowId === rowId) {
          item.data.isActive = value;
        }
        return item;
      });

      if (value) {
        if (!updateIds.includes(rowId)) {
          updateIds.push(rowId);
        }
      } else {
        updateIds = updateIds.filter((id) => id !== rowId);
      }
    }
    updateIds = [...new Set(updateIds)];
    this.props.setActiveIds(updateIds);
    const allSelected = updatedData.every((item) => item.data.isActive == 1);
    const allCheckbox = document.getElementById("ALL");
    if (allCheckbox) {
      allCheckbox.checked = allSelected;
    }
    if (!allSelected) {
      this.props.setSelectedAllRecords(false);
    }
    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          data: updatedData,
        },
      },
    }));
  };
  filterOnClick = () => {
    this.setState(
      {
        filterOpen: !this.state.filterOpen,
      },
      () => {
        if (document.body.classList.contains("filterOpened")) {
          document.body.classList.remove("filterOpened");
          // menuToggleElement.removeClass('active');
        } else {
          document.body.classList.add("filterOpened");
        }
      }
    );
  };
  filterCloseHandler = (isClear = true) => {
    if (isClear) {
      this.clearFiltersHandler();
    } else {
      this.setState(
        {
          filterOpen: false,
        },
        () => {
          if (document.body.classList.contains("filterOpened")) {
            document.body.classList.remove("filterOpened");
            // menuToggleElement.removeClass('active');
          } else {
            document.body.classList.add("filterOpened");
          }
        }
      );
    }
  };
  detailViewModal = (empId) => {
    this.setState((oldState) => ({
      isDetailViewOpen: !oldState.isDetailViewOpen,
      detailViewId: empId,
    }));
    if (empId == null) {
      this.fetchVisitsList();
    }
  };
  followUpModelHandler = (visit_id = "", clinic_id = null) => {
    this.setState({
      isFollowUpModelOpen: !this.state.isFollowUpModelOpen,
      visitDetailViewId: visit_id,
      followUpClinicId: clinic_id,
    });
  };
  addPhysicalToogleHandler = (visitId = "") => {
    this.setState({
      isPhysicalModelOpen: !this.state.isPhysicalModelOpen,
      visitDetailViewId: visitId,
    });
  };
  setActiveTab = (val) => {
    let { Tab, filters } = this.state;
    const { label, name, isActive } = val;
    let updatedTab = Tab.map((item) => {
      if (item.label == label) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    this.setState(
      (prevState) => ({
        Tab: updatedTab,
        filters: { ...prevState.filters, ["visit_status"]: name },
      }),
      () => this.submitFiltersHandler()
    );
  };
  setActiveScheduled = (val) => {
    let { scheduledType, filters } = this.state;
    const { label, name, isActive } = val;
    let updatedTab = scheduledType.map((item) => {
      if (item.label == label) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    this.setState(
      (prevState) => ({
        scheduledType: updatedTab,
        filters: { ...prevState.filters, ["is_scheduled_visit"]: name },
      }),
      () => this.submitFiltersHandler()
    );
  };
  anyCheckboxSelected = () => {
    const { tableRows } = this.state.tableRecords;
    if (!tableRows || !Array.isArray(tableRows.data)) {
      return false;
    }

    return tableRows.data.some(
      (item) => item.data?.isActive === 1 || item.data?.isActive === true
    );
  };
  bulkDownload = async (ids) => {
    const { filters } = this.state;
    const globalFilter = this.props?.globalFilter?.Visits || {};
    const payload = {
      type: "visit_report",
      visit_ids: ids,
      ...filters,
      ...globalFilter,
    };
    const response = await CsvService.downloadCsvReport(payload);
    if (response && response.code && response.code == OK && response.data) {
      FileManagerService.downloadCsv(response.data, "visit_report");
    } else {
      this.props.Toast.error("Invalid CSV data for process");
    }
  };
  bulkSendQuestionnaire =async(ids)=>{
    this.props.Loader(true);
    const {filters}=this.state;
    const globalFilter=this.props?.globalFilter?.Visits || {};
    const payload = {
      visit_ids: ids,
     'baseUrl':process.env.REACT_APP_BASEURL,
    };
    const response=await VisitsService.getQuestionnaireList(payload);
    this.props.Loader(false);
    this.props.Toast.success("Questionnaire sent successfully");
    this.fetchVisitsList()
  }
  SendQuestionnaire = async (visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const response = await VisitsService.getQuestionnaireList({
        visit_id: visitId,
        baseUrl: process.env.REACT_APP_BASEURL,
      });
      if (response?.code === 422 || response?.status === "ERROR") {
        const msg =
          typeof response?.data === "string"
            ? response.data
            : "No questionnaires available to send for this visit.";
        Toast.error(msg);
        return;
      }
      Toast.success("Questionnaire link sent successfully");
      this.fetchVisitsList();
    } catch (err) {
      const msg =
        err?.data?.data ||
        err?.data?.message ||
        (typeof err?.data === "string" ? err.data : "Failed to send questionnaires");
      Toast.error(msg);
    } finally {
      Loader(false);
    }
  };
  sendResultEmail = async (ids) => {
    const { filters } = this.state;
    const globalFilter = this.props?.globalFilter?.Visits || {};
    const payload = {
      visit_ids: ids,
      ...filters,
      ...globalFilter,
    };
    const response = await VisitsService.sentResultNotification(payload);
    this.props.Toast.success("Mail sent successfully");
    this.fetchVisitsList();
  };

  printScheduleHandler = async (ids) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const { filters } = this.state;
      const globalFilter = this.props?.globalFilter?.Visits || {};
      const payload = {
        visit_ids: ids === 'ALL' ? 'ALL' : ids,
        ...filters,
        ...globalFilter,
      };
      const pdfData = await VisitsService.printSchedule(payload);
      if (pdfData) {
        FileManagerService.printPdf({
          file_content: pdfData,
          original_name: "visit-schedule",
          mime_type: "application/pdf",
        });
        Toast.success("Visit schedule printed successfully");
      } else {
        Toast.error("Failed to print visit schedule");
      }
    } catch (error) {
      console.error("Error printing visit schedule:", error);
      Toast.error("Failed to print visit schedule");
    } finally {
      Loader(false);
    }
  };

  bulkSubmitToDaisyBill = async (ids) => {
    const { Loader, Toast } = this.props;
    
    if (!ids || ids.length === 0) {
      Toast.error("Please select at least one visit to submit");
      return;
    }

    // Get visit details to filter only Work Comp visits (New Injury and Follow Up)
    const { tableRows } = this.state.tableRecords;
    const selectedVisits = tableRows.data.filter((item) => ids.includes(item.rowId));
    console.log("selectedVisits",selectedVisits);
    // Filter only Work Comp - New Injury, Work Comp - Follow Up, and Work Comp - Physical Therapy visits
    const workCompVisits = selectedVisits.filter((item) => {
      // Check the original visit_category that was preserved before formatting
      const visitCategory = item.data?._original_visit_category || item.data?.visit_category;
      return (
        visitCategory === "Work Comp - New Injury" ||
        visitCategory === "Work Comp - Follow Up" ||
        visitCategory === "Work Comp - Physical Therapy"
      );
    });
    console.log("workCompVisits",workCompVisits); 
    if (workCompVisits.length === 0) {
      Toast.error(
        "No Work Comp visits selected. This feature is only available for Work Comp - New Injury, Work Comp - Follow Up, or Work Comp - Physical Therapy visits."
      );
      return;
    }

    if (workCompVisits.length < selectedVisits.length) {
      Toast.warning(`${selectedVisits.length - workCompVisits.length} visit(s) skipped (not Work Comp visits). Processing ${workCompVisits.length} visit(s)...`);
    }

    Loader(true);
    let successCount = 0;
    let errorCount = 0;
    const errors = [];
    const successfulBills = []; // Store successful bill submissions

    // Process each visit sequentially
    for (const visitItem of workCompVisits) {
      const visitId = visitItem.rowId;
      const visitData = visitItem.data;
      
      // Extract visit details for error messages
      // Patient name can be from employee object (spread from visit) or from formatted employee_name
      const patientName = visitData?.employee?.first_name && visitData?.employee?.last_name
        ? `${visitData.employee.first_name} ${visitData.employee.last_name}`
        : visitData?.employee_name?.[0]?.label 
        ? visitData.employee_name[0].label
        : "Unknown Patient";
      // Visit date can be from original visit object or formatted visit_date.value
      const visitDate = visitData?.visit_date?.value || visitData?.visit_date || "N/A";
      // Visit time can be from original visit object or formatted visit_time.value
      const visitTime = visitData?.visit_time?.value || visitData?.visit_time || "N/A";
      
      try {
        const result = await DaisyBillService.processNewInjuryBilling(visitId);
        
        // Handle different response structures
        let responseData = result;
        if (result?.data && result.data.success !== undefined) {
          responseData = result.data;
        }
        
        if (responseData && responseData.success) {
          successCount++;
          // Store successful bill info for document upload
          if (responseData.bill_id) {
            successfulBills.push({
              billId: responseData.bill_id,
              visitId: visitId,
              patientName: patientName,
              visitDate: visitDate,
              visitTime: visitTime
            });
          }
        } else {
          errorCount++;
          // Format validation errors if they exist
          let errorMessage = responseData?.message || "Unknown error";
          if (responseData?.errors) {
            errorMessage = this.formatValidationErrors(responseData.errors, responseData.message);
          }
          errors.push({
            patientName,
            visitDate,
            visitTime,
            errorMessage,
            visitId,
            errors: responseData?.errors || null
          });
        }
      } catch (error) {
        errorCount++;
        let errorMessage = error?.data?.data?.message || error?.message || "Failed to submit";
        // Check if validation errors exist in error response
        if (error?.response?.data?.data?.errors) {
          errorMessage = this.formatValidationErrors(error.response.data.data.errors, error.response.data.data.message);
        } else if (error?.data?.data?.errors) {
          errorMessage = this.formatValidationErrors(error.data.data.errors, error.data.data.message);
        }
        errors.push({
          patientName,
          visitDate,
          visitTime,
          errorMessage,
          visitId,
          errors: error?.response?.data?.data?.errors || error?.data?.data?.errors || null
        });
      }
    }

    // Auto-upload chart note for each successful bill (replaces manual document upload modal)
    if (successfulBills.length > 0) {
      for (const bill of successfulBills) {
        try {
          const pdfResponse = await EmrVisitsService.getCombinedChartNotePdf(bill.visitId, true);
          const base64Data = typeof pdfResponse === "string" ? pdfResponse : pdfResponse?.data ?? pdfResponse;
          if (base64Data && typeof base64Data === "string" && base64Data.length > 0) {
            const attachResult = await DaisyBillService.attachDocumentToBill(
              bill.billId,
              base64Data,
              "M1" // M1 - Medical Record Attachment (Daisy Bill report type)
            );
            if (attachResult?.success) {
              Toast.success(`Docuemnt uploaded for ${bill.patientName}`, 4000);
            } else {
              Toast.error(attachResult?.message || `Chart note upload failed for ${bill.patientName}`, 6000);
            }
          } else {
            Toast.error(`Could not generate chart note PDF for ${bill.patientName}`, 6000);
          }
        } catch (uploadErr) {
          console.error("Error auto-uploading chart note for visit", bill.visitId, uploadErr);
          const uploadErrMsg = uploadErr?.response?.data?.data?.message || uploadErr?.message || "Failed to upload chart note";
          Toast.error(`${bill.patientName}: ${uploadErrMsg}`, 6000);
        }
      }
    }

    Loader(false);

    // --- Manual document upload modal (commented out - auto-upload used instead) ---
    // Store successful bills in state for document upload option
    // if (successfulBills.length > 0) {
    //   this.setState({
    //     successfulBills: successfulBills,
    //     currentBillIndex: 0
    //   });
    //   // Auto-open document upload modal for the first successful bill
    //   if (successfulBills.length > 0) {
    //     const firstBill = successfulBills[0];
    //     setTimeout(() => {
    //       this.openDaisyBillDocumentUpload(firstBill.billId, {
    //         patientName: firstBill.patientName,
    //         visitDate: firstBill.visitDate,
    //         visitTime: firstBill.visitTime
    //       }, 0);
    //     }, 500);
    //   }
    // }
    
    // Show individual toasts for each error with shorter timeout
    const ERROR_TOAST_TIMEOUT = 10000; // 10 seconds per toast
    
    if (successCount > 0 && errorCount === 0) {
      const message = successfulBills.length > 0 
        ? `Successfully submitted ${successCount} visit(s) to Daisy Bill. Chart note(s) uploaded automatically.`
        : `Successfully submitted ${successCount} visit(s) to Daisy Bill`;
      Toast.success(message);
    } else if (successCount > 0 && errorCount > 0) {
      // Show success message first
      Toast.success(`Successfully submitted ${successCount} visit(s) to Daisy Bill.`);
      
      // Show individual error toasts for each failed visit with a delay
      errors.forEach((error, index) => {
        setTimeout(() => {
          const errorTitle = `❌ ${error.patientName} - Visit Failed`;
          const errorDetails = `Date: ${error.visitDate} | Time: ${error.visitTime}\n\n${error.errorMessage}`;
          Toast.error(`${errorTitle}\n${errorDetails}`, ERROR_TOAST_TIMEOUT);
        }, index * 1000); // Stagger toasts by 1 second each
      });
      
      // Also log all detailed errors to console
      console.error("Daisy Bill submission errors (all details):", errors);
      errors.forEach((error, index) => {
        console.error(`${index + 1}. ${error.patientName} - ${error.visitDate} ${error.visitTime}: ${error.errorMessage}`);
      });
    } else {
      // Show individual error toasts for each failed visit with a delay
      errors.forEach((error, index) => {
        setTimeout(() => {
          const errorTitle = `❌ ${error.patientName} - Visit Failed`;
          const errorDetails = `Date: ${error.visitDate} | Time: ${error.visitTime}\n\n${error.errorMessage}`;
          Toast.error(`${errorTitle}\n${errorDetails}`, ERROR_TOAST_TIMEOUT);
        }, index * 1000); // Stagger toasts by 1 second each
      });
      
      // Also log all detailed errors to console
      console.error("Daisy Bill submission errors (all details):", errors);
      errors.forEach((error, index) => {
        console.error(`${index + 1}. ${error.patientName} - ${error.visitDate} ${error.visitTime}: ${error.errorMessage}`);
      });
    }

    // Refresh the visits list to update billing status
    this.fetchVisitsList();
  };

  // Format validation errors into a readable message
  formatValidationErrors = (errors, baseMessage = "Please fix the following validation errors:") => {
    if (!errors || typeof errors !== 'object') {
      return baseMessage;
    }

    let errorMessages = [];

    // Patient errors
    if (errors.patient) {
      Object.keys(errors.patient).forEach(field => {
        const fieldErrors = Array.isArray(errors.patient[field]) 
          ? errors.patient[field] 
          : [errors.patient[field]];
        fieldErrors.forEach(err => {
          errorMessages.push(`Patient ${field.replace(/_/g, ' ')}: ${err}`);
        });
      });
    }

    // Injury errors
    if (errors.injury) {
      Object.keys(errors.injury).forEach(field => {
        const fieldErrors = Array.isArray(errors.injury[field]) 
          ? errors.injury[field] 
          : [errors.injury[field]];
        fieldErrors.forEach(err => {
          errorMessages.push(`Injury ${field.replace(/_/g, ' ')}: ${err}`);
        });
      });
    }

    // Bill errors
    if (errors.bill) {
      Object.keys(errors.bill).forEach(field => {
        if (field === 'orders' && Array.isArray(errors.bill[field])) {
          errors.bill[field].forEach(err => {
            errorMessages.push(`Bill Orders: ${err}`);
          });
        } else {
          const fieldErrors = Array.isArray(errors.bill[field]) 
            ? errors.bill[field] 
            : [errors.bill[field]];
          fieldErrors.forEach(err => {
            errorMessages.push(`Bill ${field.replace(/_/g, ' ')}: ${err}`);
          });
        }
      });
    }

    // Other errors (including followup_mapping, incident, etc.)
    Object.keys(errors).forEach(key => {
      if (!['patient', 'injury', 'bill'].includes(key)) {
        const fieldErrors = Array.isArray(errors[key]) 
          ? errors[key] 
          : [errors[key]];
        fieldErrors.forEach(err => {
          // Format followup_mapping error more clearly
          if (key === 'followup_mapping') {
            errorMessages.push(err);
          } else {
            // Format other keys (replace underscores with spaces, capitalize)
            const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            errorMessages.push(`${formattedKey}: ${err}`);
          }
        });
      }
    });

    // Join all errors, each on a new line with bullet points
    return errorMessages.length > 0 
      ? `${baseMessage}\n\n${errorMessages.map(err => `• ${err}`).join('\n')}`
      : baseMessage;
  };

  // --- Manual document upload modal handlers (commented out - auto-upload used instead) ---
  // openDaisyBillDocumentUpload = (billId, visitInfo, billIndex = null) => {
  //   this.setState({
  //     daisyBillDocumentModalOpen: true,
  //     selectedBillForDocument: billId,
  //     selectedVisitInfoForDocument: visitInfo,
  //     currentBillIndex: billIndex !== null ? billIndex : this.state.currentBillIndex
  //   });
  // };
  // handleDaisyBillDocumentModalClose = () => {
  //   const { successfulBills, currentBillIndex } = this.state;
  //   this.setState({
  //     daisyBillDocumentModalOpen: false,
  //     selectedBillForDocument: null,
  //     selectedVisitInfoForDocument: null
  //   });
  //   if (successfulBills && successfulBills.length > 0 && currentBillIndex !== null) {
  //     const nextIndex = currentBillIndex + 1;
  //     if (nextIndex < successfulBills.length) {
  //       const nextBill = successfulBills[nextIndex];
  //       setTimeout(() => {
  //         this.openDaisyBillDocumentUpload(nextBill.billId, {
  //           patientName: nextBill.patientName,
  //           visitDate: nextBill.visitDate,
  //           visitTime: nextBill.visitTime
  //         }, nextIndex);
  //       }, 300);
  //     } else {
  //       this.setState({ successfulBills: [], currentBillIndex: 0 });
  //     }
  //   }
  // };

  // Print Consent form for ES-Physicals
  printConsentHandler = async (visitId, labelName = "Consent Form") => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      // For visit-level consent forms, we can pass empty query filters
      // The API should handle visit-level consent forms based on visitId
      const queryfilters = {};
      const data = await PatientChartsService.getPrintConsent(
        null,
        queryfilters,
        visitId
      );
      if (!data) {
        Toast.error("Consent Form Not Found");
        Loader(false);
        return;
      }
      const pdfData = {
        file_content: data,
        original_name: `${labelName}`,
        mime_type: "application/pdf",
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.log("e", e);
      Toast.error("Something went wrong");
    }
    Loader(false);
  };

  //Print Intake Form for ES - Physicals
      printIntakeHandler = async (visitId = '', visitCategory = '', snapEmployeeDetails = null) => {
         const { Loader } = this.props;
         const employee_id = snapEmployeeDetails?.employee_id;
         Loader(true);
    try {
      const data = await ConsentFormService.getVisitConsentPDF(
        isSet(OrganizationService.getOrgId(), null),
        visitId,
        visitCategory,
        employee_id
      );
      const pdfData = {
        file_content: data,
        original_name: `visit-consent`,
        mime_type: 'application/pdf'
      };
      FileManagerService.printPdf(pdfData);
    } catch (e) {
      console.log('e', e);
    }
    Loader(false);
  }
  navigateToVisitDetails = (visitId, employeeId) => {
    const queryParams = new URLSearchParams();
    queryParams.append('employee_id', employeeId);
    queryParams.append('visit_id', visitId);
    this.props.navigate(`/result/physical-drug-screens?${queryParams.toString()}`);
  }

  openTranscriptionWorkflow = (visit) => {
    const visitId = visit?.visit_id;
    if (!visitId) return;
    this.setState({
      showTranscriptionModal: true,
      transcriptionVisitId: visitId,
      transcriptionVisitData: visit,
    });
  };

  closeTranscriptionModal = () => {
    this.setState({
      showTranscriptionModal: false,
      transcriptionVisitId: null,
      transcriptionVisitData: null,
    });
    this.fetchVisitsList({}, false);
  };

  getHeaderButtons = () => {
    const HeaderButtons = [
      {
        className: "btn btn-icon btn-transparent-dark",
        iconType: "Remove",
        acl: "visits-delete",
        title: "Delete",
        isDelete: true,
        contentTitle: "Warning",
        contentType: "warning",
        content:
          "Selected visits may have associated activities. Are you sure you want to delete the records?",
        clickHandler: this.bulkDeleteHandler,
      },
      // {
      //   className: "btn btn-icon btn-transparent-dark",
      //   iconType: "Edit",
      //   acl: "visits-edit",
      //   title: "Bulk Edit",
      //   clickHandler: (visit_ids)=>this.openMiniPopup(visit_ids,null),
      // },
      {
        className: "btn btn-link p-0",
        acl: PERMISSIONS.VISITS.EDIT,
        iconType: "Edit",
        title: "Bulk Edit",
        label: "Bulk Edit",
        btnLabel: "Bulk Edit",
        clickHandler: (visit_ids) => this.openMiniPopup(visit_ids, null),
      },
      {
        className: "btn btn-link p-0",
        acl: PERMISSIONS.VISITS.EDIT,
        iconType: "Edit",
        title: "Billing Edit",
        label: "Billing Edit",
        btnLabel: "Billing Edit",
        clickHandler: (visit_ids) => this.billingStatusHandler(visit_ids),
      },
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        acl: PERMISSIONS.VISITS.LIST,
        iconType: "Download",
        title: "Bulk Download",
        clickHandler: this.bulkDownload,
      },
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        acl: PERMISSIONS.VISITS.SEND_EMAIL,
        iconType: "DashboardMessage",
        title: "Sent Email",
        iconColor: "#1500ff",
        iconOpacity: "none",
        clickHandler: this.sendResultEmail,
      },
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        acl: "any",
        iconType: "BulkQuestionSend",
        title: "Send Questionnaire",
        iconColor:"#1500ff",
        iconOpacity:'none' ,
        clickHandler: this.bulkSendQuestionnaire,
      },
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        acl: PERMISSIONS.VISITS.SUBMIT_TO_DAISY_BILL,
        iconType: "BillIcon",
        title: "Bulk Send to Daisy Bill",
        iconColor: "#1500ff",
        iconOpacity: "none",
        clickHandler: this.bulkSubmitToDaisyBill,
      },
      {
        className: "btn btn-icon btn-transparent-dark ml-1",
        acl: PERMISSIONS.VISITS.LIST,
        iconType: "Print",
        title: "Print Schedule",
        clickHandler: this.printScheduleHandler,
      }
    ];
    return HeaderButtons;
  };
}
VisitsListNew.defaultProps = {
  isFromVisitHistory: false,
};
const mapStateToProps = (state) => {
  return {
    activeIds: state.globalFilter.checkbox.cbActiveIds,
    selectedAllRecords: state.globalFilter.checkbox.cbSelectedAllRecords,
    showScheduledVisits: getShowScheduledVisits(state),
  };
};
const mapDispatchToProps = (dispatch) => ({
  setSelectedAllRecords: (payload) => dispatch(setSelectedAllRecords(payload)),
  setActiveIds: (payload) => dispatch(setActiveIds(payload)),
  clearCbState: (payload) => dispatch(clearCbState()),
  setShowScheduledVisits: (payload) => dispatch(setShowScheduledVisits(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithRouter(withReduxState(WithRoutify(WithDropdownState(VisitsListNew)))));
